import React, { useState } from 'react'
import {
  Row,
  Button,
  Select,
  Card,
  Col,
  Form,
  Input,
  Space,
  Radio,
  Typography,
  Divider,
  Spin,
  Checkbox
} from 'antd'

import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import InputMask from 'react-input-mask'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import 'rc-time-picker/assets/index.css';
import { EmptyHeaderHero, SEO } from './components'
import { sendEmailForClaimsFNOL, sendFNOLData } from '../services/Api'
import TimePickerCustom from './TimePickerCustom/TimePickerCustom'

import FNOLStyle from '../../styles/FNOLClaims.module.css'

const { Text, Paragraph } = Typography

const dd_format = 'h:mm A';
const { Option } = Select
const { TextArea } = Input
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

dayjs.extend(customParseFormat)

const CLAIMS_OPTIONS = [
  {
    id: 'i-am-insured-with-cure',
    label: 'I am insured with CURE'
  },
  {
    id: 'i-had-an-accident-with-a-cure-customer',
    label: 'I had an accident with a CURE customer'
  }
]

const STATE_OPTIONS = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" }
];


const VEHICLE_INFO = {
  year: 'Year',
  model: 'Model',
  make: 'Make',
  vin: 'VIN',
  owner: 'Owner',
  describeDamage: 'Describe damage',
  isAirbagDeployed: 'Airbags deployed?',
  isDrivable: 'Drivable',
  isTowed: 'Towed',
  towedReason: 'Vehicle towed location',
  isDamaged: 'Prior Damage?',
  priorDamage: 'Was there any prior damage to the vehicle before the accident?',
  registeredTo: 'Registered to?',
  carrierName: 'Carrier Name',
  carrierClaimNo: 'Carrier Claim #',
  describeProperty: 'Describe Property',
  isSameAsOwner: 'Same as Owner',
  driverNameAndAddress: 'Drivers name and address',
  primaryPhoneNumber: 'PhoneNumber',
  primaryPhone: 'Primary Phone',
  isSameAsOwner: 'Same as owner',
  otherCarrierName: 'Other Carrier Name',
  otherCarrierClaim: 'Other Carrier Claim #',
  emailAddress: 'EmailAddress'
}

const CURE_DRIVER_INFO = {
  PhoneNumber: 'PhoneNumber',
  EmailAddress: 'EmailAddress',
  relationToINSD: 'Relation to INSD (Employee, family, etc)',
  dob: 'Date of birth',
  FirstName: 'First Name',
  LastName: 'Last Name',
  StreetAddress: 'Street Address',
  ApartmentNo: "Apartment #",
  City: 'City',
  State: 'State',
  ZipCode: 'Zip Code',
  relationToPolicyholder: 'Relationship to the Policyholder'
}

const LOSS_INFORMATION = {
  StreetAddress: 'StreetAddress',
  State: 'State',
  policeContacted: 'Police contacted',
  descriptionOfAccident: 'Description of accident',
  ApartmentNo: "Apartment #",
  City: 'City',
  ZipCode: 'ZipCode'
}

const anyOtherVehiclesInvolved = 'Were there any other vehicles or property damaged in the loss?'
const VEHICLE_INVOLVED = {
  year: 'Year',
  model: 'Model',
  make: 'Make',
  otherCarrierName: 'Other Carrier Name',
  otherCarrierClaim: 'Other Carrier Claim #',
  describeProperty: 'Describe Property (If it is a non-vehicle)',
  primaryPhoneNumber: 'PrimaryPhoneNumber',
  emailAddress: 'EmailAddress',
  driverNameAndAddress: 'Drivers name and address',
  describeDamage: 'Describe damage',
  isSameAsOwner: 'Same as owner'
}
const isAnyOtherVehicleInvolvedInLoss = 'Were there any other vehicles or property damaged in the loss?'
const wereThereAnyInjuriesInLoss = 'Was anyone else injured in this loss?'
const wereThereAnyPassengersInVehicle = 'Were there any passengers in your vehicle?'
const injuriesInLossLists = {
  name: 'Name & Address',
  phone: 'Phone #',
  address: 'Extend of Injury'
}

const FNOL = () => {
  const [selectedClaim, setSelectedClaim] = useState(null)
  const [message, setMessage] = useState(null)
  const [insuredUser, setInsuredUser] = useState({
    user: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: ''
    },
    lossInfo: {
      DateOfLoss: '',
      TimeOfLoss: ''
    },
    policyHolderInfo: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      PolicyNumber: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: ''
    },
    vehicleInfo: {
      year: '',
      model: '',
      make: '',
      vin: '',
      owner: '',
      describeDamage: '',
      isAirbagDeployed: '',
      isDrivable: '',
      isTowed: '',
      towedReason: '',
      isDamaged: '',
      priorDamage: '',
      registeredTo: ''
    },
    cureDriverInfo: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: '',
      relationToPolicyholder: ''
    },
    lossInformation: {
      StreetAddress: '',
      City: '',
      ZipCode: '',
      policeContacted: '',
      descriptionOfAccident: ''
    },
    vehicleInvolved: [{
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      ownerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: ''
      },
    }],
    anyOtherVehiclesInvolved: '',
    injuriesInLossLists: [
      {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: '',
        description: ''
      }
    ],
    passengersInvehiclesLists: [
      {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: '',
        isPersonInjured: '',
        description: ''
      }
    ],
    wereThereAnyInjuriesInLoss: '',
    wereThereAnyPassengersInVehicle: ''
  })
  const [mandatoryInsuredUser, setMandatoryInsuredUser] = useState({
    user: {},
    lossInfo: {},
    policyHolderInfo: {},
    ownerInfo: {},
    vehicleInfo: {},
    vehicleInvolved: [{
      ownerInfo: {
        FirstName: false,
        LastName: false
      },
    }],
    anyOtherVehiclesInvolved,
    cureDriverInfo: {},
    lossInformation: {},
    wereThereAnyInjuriesInLoss,
    injuriesInLossLists: [{}],
    wereThereAnyPassengersInVehicle,
    passengersInvehiclesLists: [{}]
  })
  const [mandatoryAccidentalUser, setMandatoryAccidentalUser] = useState({
    user: {},
    lossInfo: {},
    policyHolderInfo: {},
    ownerInfo: {},
    lossInformation: {},
    cureDriverInfo: {},
    vehicleInvolved: [{
      cureOwnerInfo: {
        City: false,
        State: false,
        FirstName: false,
        LastName: false,
        StreetAddress: false,
        ApartmentNo: false,
        ZipCode: false
      },
    }],
    anyOtherVehiclesInvolved,
    wereThereAnyInjuriesInLoss,
    injuriesInLossLists: [{}],
    wereThereAnyPassengersInVehicle,
    passengersInvehiclesLists: [{}]
  })
  const [accidentUser, setAccidentUser] = useState({
    user: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: ''
    },
    lossInfo: {
      DateOfLoss: '',
      TimeOfLoss: ''
    },
    ownerInfo: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: ''
    },
    policyHolderInfo: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      PolicyNumber: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: ''
    },
    vehicleInfo: {
      year: '',
      model: '',
      make: '',
      carrierName: '',
      carrierClaimNo: '',
      describeProperty: ''
    },
    lossInformation: {
      policeContacted: '',
      descriptionOfAccident: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: ''
    },
    cureVehicleInfo: {
      year: '',
      model: '',
      make: '',
      describeProperty: ''
    },
    vehicleInvolved: [{
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      describeDamage: '',
      cureOwnerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: ''
      }
    }],
    cureDriverInfo: {
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      StreetAddress: '',
      ApartmentNo: '',
      City: '',
      State: '',
      ZipCode: ''
    },
    anyOtherInjuries: '',
    wereThereAnyInjuriesInLoss: '',
    wereThereAnyPassengersInVehicle: '',
    injuriesInLossLists: [
      {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: '',
        description: ''
      }
    ],
    passengersInvehicles: '',
    passengersInvehiclesLists: [
      {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        ApartmentNo: '',
        City: '',
        State: '',
        ZipCode: '',
        isPersonInjured: '',
        description: ''
      }
    ]
  })
  const [policyHolderInfo, setPolicyHolderInfo] = useState({
    FirstName: '',
    LastName: '',
    PhoneNumber: '',
    EmailAddress: '',
    PolicyNumber: '',
    StreetAddress: '',
    ZipCode: ''
  })

  const [displayAccidentMissingFieldMessage, setDisplayAccidentMissingFieldMessage] = useState(false)
  const [displayInsuredMissingFieldMessage, setDisplayInsuredMissingFieldMessage] = useState(false)
  const [displayBlockedMessage, setDisplayBlockedMessage] = useState(false)
  const [showInsuredSpinner, setShowInsuredSpinner] = useState(false)
  const [showAccidentSpinner, setShowAccidentSpinner] = useState(false)
  const [insuredAttested, setInsuredAttested] = useState(false)
  const [accidentAttested, setAccidentAttested] = useState(false)
  const [alreadySubmitted, setAlreadySubmitted] = useState(false)
  const [form] = Form.useForm()

  const updateUserTextFields = (text, typeOfUser, field) => {
    const clonedUser = (typeOfUser == "insured") ? { ...insuredUser.user } : { ...accidentUser.user }
    clonedUser[field] = text

    if (typeOfUser == "insured") {
      setInsuredUser({
        ...insuredUser,
        user: clonedUser
      })
    }
    else {
      setAccidentUser({
        ...accidentUser,
        user: clonedUser
      })
    }
  }

  const buildInsuredData = insuredUser => {
    var table = '<table border="1">'
    table += '<tr><td>Who is reporting the claim today:</td><td>I am insured with CURE</td></tr>'
    table += '<tr><td colspan="2" style="text-align: center"><b>Your Information</b></td></tr>'
    for (const key in insuredUser.user) {
      table += `<tr><td>${key}</td><td>${insuredUser.user[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>Loss Information</b></td></tr>'
    for (const key in insuredUser.lossInfo) {
      table += `<tr><td>${key}</td><td>${insuredUser.lossInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Policy Information</b></td></tr>'
    for (const key in insuredUser.policyHolderInfo) {
      table += `<tr><td>${key}</td><td>${insuredUser.policyHolderInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Vehicle Information</b></td></tr>'
    for (const key in insuredUser.vehicleInfo) {
      table += `<tr><td>${VEHICLE_INFO[key]}</td><td>${insuredUser.vehicleInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Driver Information</b></td></tr>'
    for (const key in insuredUser.cureDriverInfo) {
      table += `<tr><td>${CURE_DRIVER_INFO[key]}</td><td>${insuredUser.cureDriverInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>Loss Information</b></td></tr>'
    for (const key in insuredUser.lossInformation) {
      table += `<tr><td>${LOSS_INFORMATION[key]}</td><td>${insuredUser.lossInformation[key]}</td></tr>`
    }
    table += `<tr><td>${anyOtherVehiclesInvolved}</td><td>${insuredUser.anyOtherVehiclesInvolved}</td></tr>`

    if (insuredUser.anyOtherVehiclesInvolved === 'Yes') {
      insuredUser.vehicleInvolved.forEach((item, vehicleIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Other Vehicle Information ${vehicleIndex + 1}</b></td></tr>`
        for (const key in item) {
          if (key !== 'ownerInfo' && key.toUpperCase() !== 'DESCRIBEDAMAGE') {
            table += `<tr><td>${key.toUpperCase() === 'DESCRIBEPROPERTY' ? 'DESCRIBE THE VEHICLE OR PROPERTY DAMAGE' : key.toUpperCase()}</td><td>${item[key]}</td></tr>`
          }
          if (key === 'ownerInfo') {
            for (const ownerKey in item.ownerInfo) {
              table += `<tr><td>${ownerKey}</td><td>${item.ownerInfo[ownerKey]}</td></tr>`
            }
          }
        }
      })
    }
    for (const key in insuredUser.otherVehicleInvolved) {
      table += `<tr><td>${VEHICLE_INVOLVED[key]}</td><td>${insuredUser.otherVehicleInvolved[key]}</td></tr>`
    }
    table += `<tr><td>${wereThereAnyInjuriesInLoss}</td><td>${insuredUser.wereThereAnyInjuriesInLoss}</td></tr>`
    if (insuredUser.wereThereAnyInjuriesInLoss === 'Yes') {
      insuredUser.injuriesInLossLists.forEach((item, injuryIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Injured Person ${injuryIndex + 1}</b></td></tr>`
        for (const key in item) {
          table += `<tr><td>${key}</td><td>${item[key]}</td></tr>`
        }
      })
    }
    table += `<tr><td>${wereThereAnyPassengersInVehicle}</td><td>${insuredUser.wereThereAnyPassengersInVehicle}</td></tr>`
    if (insuredUser.wereThereAnyPassengersInVehicle === 'Yes') {
      insuredUser.passengersInvehiclesLists.forEach((item, passengerIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Other Passenger ${passengerIndex + 1}</b></td></tr>`
        for (const key in item) {
          table += `<tr><td>${key}</td><td>${item[key]}</td></tr>`
        }
      })
    }
    table += `<tr><td colspan="2" style="text-align: center"><b>Attestation</b></td></tr>`
    table += `<tr><td width="50%">I hereby certify that, to the best of my knowledge, the provided information is true and accurate.† †The Michigan Department of Insurance and Financial Services defines insurance fraud as providing “false information to an insurance company in order to gain something of value that he or she would not have received if the truth had been told[.]” Under Michigan law, it is unlawful to present to any insurer or agent thereof any oral or written statement knowing that the statement contains any false information concerning any fact material to an application for the issuance of an insurance policy or a claim. †Pursuant to New Jersey regulations, “Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.” †Pursuant to Pennsylvania regulations, “Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.”</td><td>"Yes"</td></tr>`
    table += '</table>'
    return table
  }

  const buildAccidentalData = accidentUser => {
    var table = '<table border="1">'
    table += '<tr><td>Who is reporting the claim today</td><td>I had an accident with a CURE customer</td></tr>'
    table += '<tr><td colspan="2" style="text-align: center"><b>Your Information</b></td></tr>'
    for (const key in accidentUser.user) {
      table += `<tr><td>${key}</td><td>${accidentUser.user[key]}</td></tr>`
    }
    table += `<tr><td>Preferred Delivery Method</td><td>${accidentUser.preferredDeliveryMethod || ''}</td></tr>`
    table += '<tr><td colspan="2" style="text-align: center"><b>Loss Information</b></td></tr>'
    for (const key in accidentUser.lossInfo) {
      table += `<tr><td>${key}</td><td>${accidentUser.lossInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Policy Information</b></td></tr>'
    for (const key in accidentUser.policyHolderInfo) {
      table += `<tr><td>${key}</td><td>${accidentUser.policyHolderInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>Your Vehicle Information</b></td></tr>'
    for (const key in accidentUser.vehicleInfo) {
      table += `<tr><td>${VEHICLE_INFO[key]}</td><td>${accidentUser.vehicleInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>Owner Information</b></td></tr>'
    for (const key in accidentUser.ownerInfo) {
      table += `<tr><td>${key}</td><td>${accidentUser.ownerInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>Loss Information</b></td></tr>'
    for (const key in accidentUser.lossInformation) {
      table += `<tr><td>${LOSS_INFORMATION[key]}</td><td>${accidentUser.lossInformation[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Vehicle Information</b></td></tr>'
    for (const key in accidentUser.cureVehicleInfo) {
      table += `<tr><td>${VEHICLE_INFO[key]}</td><td>${accidentUser.cureVehicleInfo[key]}</td></tr>`
    }
    table += '<tr><td colspan="2" style="text-align: center"><b>CURE Driver Information</b></td></tr>'
    for (const key in accidentUser.cureDriverInfo) {
      table += `<tr><td>${CURE_DRIVER_INFO[key]}</td><td>${accidentUser.cureDriverInfo[key]}</td></tr>`
    }
    table += `<tr><td>${anyOtherVehiclesInvolved}</td><td>${accidentUser.anyOtherVehiclesInvolved}</td></tr>`

    if (accidentUser.anyOtherVehiclesInvolved === 'Yes') {
      accidentUser.vehicleInvolved.forEach((item, vehicleIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Other Vehicle Information ${vehicleIndex + 1}</b></td></tr>`
        for (const key in item) {
          if (key !== 'cureOwnerInfo' && key.toUpperCase() !== 'DESCRIBEDAMAGE') {
            table += `<tr><td>${key.toUpperCase() === 'DESCRIBEPROPERTY' ? 'DESCRIBE THE VEHICLE OR PROPERTY DAMAGE' : key.toUpperCase()}</td><td>${item[key]}</td></tr>`
          }
          if (key === 'cureOwnerInfo') {
            for (const ownerKey in item.cureOwnerInfo) {
              table += `<tr><td>${ownerKey}</td><td>${item.cureOwnerInfo[ownerKey]}</td></tr>`
            }
          }
        }
      })
    }

    table += `<tr><td>${wereThereAnyInjuriesInLoss}</td><td>${accidentUser.wereThereAnyInjuriesInLoss}</td></tr>`
    if (accidentUser.wereThereAnyInjuriesInLoss === 'Yes') {
      accidentUser.injuriesInLossLists.forEach((item, injuryIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Injured Person ${injuryIndex + 1}</b></td></tr>`
        for (const key in item) {
          table += `<tr><td>${key}</td><td>${item[key]}</td></tr>`
        }
      })
    }
    table += `<tr><td>${wereThereAnyPassengersInVehicle}</td><td>${accidentUser.wereThereAnyPassengersInVehicle}</td></tr>`
    if (accidentUser.wereThereAnyPassengersInVehicle === 'Yes') {
      accidentUser.passengersInvehiclesLists.forEach((item, passengerIndex) => {
        table += `<tr><td colspan="2" style="text-align: center"><b>Other Passenger ${passengerIndex + 1}</b></td></tr>`
        for (const key in item) {
          table += `<tr><td>${key}</td><td>${item[key]}</td></tr>`
        }
      })
    }
    table += `<tr><td colspan="2" style="text-align: center"><b>Attestation</b></td></tr>`
    table += `<tr><td width="50%">I hereby certify that, to the best of my knowledge, the provided information is true and accurate.† †The Michigan Department of Insurance and Financial Services defines insurance fraud as providing “false information to an insurance company in order to gain something of value that he or she would not have received if the truth had been told[.]” Under Michigan law, it is unlawful to present to any insurer or agent thereof any oral or written statement knowing that the statement contains any false information concerning any fact material to an application for the issuance of an insurance policy or a claim. †Pursuant to New Jersey regulations, “Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.” †Pursuant to Pennsylvania regulations, “Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.”</td><td>"Yes"</td></tr>`
    table += '</table>'
    console.log(table)
    return table
  }

  const buildTable = (insuredUser, accidentUser, selectedClaim) => {
    const data =
      selectedClaim === 'i-am-insured-with-cure' ? buildInsuredData(insuredUser) : buildAccidentalData(accidentUser)
    console.log(data)
    return data
  }

  const validateInsuredUserData = insuredUser => {
    let status = true
    let mandAttributesClone = {
      ...mandatoryInsuredUser
    }
    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        FirstName: insuredUser.user.FirstName ? true : false
      }
    }
    if (status) status = insuredUser.user.FirstName ? true : false
    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        LastName: insuredUser.user.LastName ? true : false
      }
    }
    if (status) status = insuredUser.user.LastName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        PhoneNumber: validatePhoneNumber(insuredUser.user.PhoneNumber).isValid ? true : false
      }
    }
    if (status) status = validatePhoneNumber(insuredUser.user.PhoneNumber).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        EmailAddress: insuredUser.user.EmailAddress ? true : false
      }
    }
    if (status) status = insuredUser.user.EmailAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInfo: {
        ...mandAttributesClone.lossInfo,
        DateOfLoss: validateDate(insuredUser.lossInfo.DateOfLoss).isValid ? true : false
      }
    }
    if (status) status = validateDate(insuredUser.lossInfo.DateOfLoss).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      vehicleInfo: {
        ...mandAttributesClone.vehicleInfo,
        year: insuredUser.vehicleInfo.year ? true : false
      }
    }
    if (status) status = insuredUser.vehicleInfo.year ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      vehicleInfo: {
        ...mandAttributesClone.vehicleInfo,
        model: insuredUser.vehicleInfo.model ? true : false
      }
    }
    if (status) status = insuredUser.vehicleInfo.model ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      vehicleInfo: {
        ...mandAttributesClone.vehicleInfo,
        make: insuredUser.vehicleInfo.make ? true : false
      }
    }
    if (status) status = insuredUser.vehicleInfo.make ? true : false

    if (insuredUser.vehicleInfo.isTowed === 'Yes') {
      mandAttributesClone = {
        ...mandAttributesClone,
        vehicleInfo: {
          ...mandAttributesClone.vehicleInfo,
          towedReason: insuredUser.vehicleInfo.towedReason ? true : false
        }
      }
      if (status) status = insuredUser.vehicleInfo.towedReason ? true : false
    }

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        FirstName: insuredUser.cureDriverInfo.FirstName ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.FirstName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        LastName: insuredUser.cureDriverInfo.LastName ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.LastName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        StreetAddress: insuredUser.cureDriverInfo.StreetAddress ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.StreetAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        City: insuredUser.cureDriverInfo.City ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.City ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        ZipCode: insuredUser.cureDriverInfo.ZipCode ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.ZipCode ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        State: insuredUser.cureDriverInfo.State ? true : false
      }
    }
    if (status) status = insuredUser.cureDriverInfo.State ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        StreetAddress: insuredUser.lossInformation.StreetAddress ? true : false
      }
    }
    if (status) status = insuredUser.lossInformation.StreetAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        City: insuredUser.lossInformation.City ? true : false
      }
    }
    if (status) status = insuredUser.lossInformation.City ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        ZipCode: insuredUser.lossInformation.ZipCode ? true : false
      }
    }
    if (status) status = insuredUser.lossInformation.ZipCode ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        descriptionOfAccident: insuredUser.lossInformation.descriptionOfAccident ? true : false
      }
    }
    if (status) status = insuredUser.lossInformation.descriptionOfAccident ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        PolicyNumber: insuredUser.policyHolderInfo.PolicyNumber ? true : false
      }
    }
    if (status) status = insuredUser.policyHolderInfo.PolicyNumber ? true : false

    if (insuredUser.anyOtherVehiclesInvolved === 'Yes') {
      const clonedVehicles = insuredUser.vehicleInvolved ? [...insuredUser.vehicleInvolved] : []
      clonedVehicles.map((vehicle, index) => {
        mandAttributesClone.vehicleInvolved[index].ownerInfo.FirstName = vehicle.ownerInfo.FirstName ? true : false
        mandAttributesClone.vehicleInvolved[index].ownerInfo.LastName = vehicle.ownerInfo.LastName ? true : false
      })

      const vehicleStatus = clonedVehicles.every(
        vehicle => vehicle.ownerInfo.FirstName && vehicle.ownerInfo.LastName
      )
      if (!vehicleStatus) status = false
    }
    console.log(status)

    if (insuredUser.wereThereAnyPassengersInVehicle === 'Yes') {
      const clonedPassengers = insuredUser.passengersInvehiclesLists ? [...insuredUser.passengersInvehiclesLists] : []
      clonedPassengers.map((passengers, index) => {
        mandAttributesClone.passengersInvehiclesLists[index].FirstName = passengers.FirstName ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].LastName = passengers.LastName ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].description = passengers.description ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].isPersonInjured = passengers.isPersonInjured ? true : false
      })

      const accidentalStatus = clonedPassengers.every(
        passenger => passenger.FirstName && passenger.LastName && (!passenger.isPersonInjured || passenger.isPersonInjured === "No" || (passenger.isPersonInjured === "Yes" && passenger.description))
      )
      if (!accidentalStatus) status = false
    }

    if (insuredUser.wereThereAnyInjuriesInLoss === 'Yes') {
      const clonedInjuries = insuredUser.injuriesInLossLists ? [...insuredUser.injuriesInLossLists] : []
      clonedInjuries.map((injuries, index) => {
        mandAttributesClone.injuriesInLossLists[index].FirstName = injuries.FirstName ? true : false
        mandAttributesClone.injuriesInLossLists[index].LastName = injuries.LastName ? true : false
        mandAttributesClone.injuriesInLossLists[index].description = injuries.description ? true : false
      })

      const insuredStatus = clonedInjuries.every(
        injuries => injuries.FirstName && injuries.LastName && injuries.description
      )
      if (!insuredStatus) status = false
    }

    mandAttributesClone.anyOtherVehiclesInvolved = insuredUser.anyOtherVehiclesInvolved
    if (mandAttributesClone.anyOtherVehiclesInvolved === "") {
      if (status) status = false
    }

    mandAttributesClone.wereThereAnyInjuriesInLoss = insuredUser.wereThereAnyInjuriesInLoss
    if (mandAttributesClone.wereThereAnyInjuriesInLoss === "") {
      if (status) status = false
    }

    mandAttributesClone.wereThereAnyPassengersInVehicle = insuredUser.wereThereAnyPassengersInVehicle
    if (mandAttributesClone.wereThereAnyInjuriesInLoss === "") {
      if (status) status = false
    }

    if (!insuredAttested) {
      status = false
    }

    setMandatoryInsuredUser(mandAttributesClone)
    return status
  }

  const validateAccidentUserData = accidentUser => {
    let status = true
    let mandAttributesClone = {
      ...mandatoryAccidentalUser
    }
    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        FirstName: accidentUser.user.FirstName ? true : false
      }
    }
    if (status) status = accidentUser.user.FirstName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        LastName: accidentUser.user.LastName ? true : false
      }
    }
    if (status) status = accidentUser.user.LastName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        PhoneNumber: validatePhoneNumber(accidentUser.user.PhoneNumber).isValid ? true : false
      }
    }
    if (status) status = validatePhoneNumber(accidentUser.user.PhoneNumber).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      user: {
        ...mandAttributesClone.user,
        EmailAddress: accidentUser.user.EmailAddress ? true : false
      }
    }
    if (status) status = accidentUser.user.EmailAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInfo: {
        ...mandAttributesClone.lossInfo,
        DateOfLoss: validateDate(accidentUser.lossInfo.DateOfLoss).isValid ? true : false
      }
    }
    if (status) status = validateDate(accidentUser.lossInfo.DateOfLoss).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        FirstName: accidentUser.policyHolderInfo.FirstName ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.FirstName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        LastName: accidentUser.policyHolderInfo.LastName ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.LastName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        PhoneNumber: validatePhoneNumber(accidentUser.policyHolderInfo.PhoneNumber).isValid ? true : false
      }
    }
    if (status) status = validatePhoneNumber(accidentUser.policyHolderInfo.PhoneNumber).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        EmailAddress: accidentUser.policyHolderInfo.EmailAddress ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.EmailAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        PolicyNumber: accidentUser.policyHolderInfo.PolicyNumber ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.PolicyNumber ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        StreetAddress: accidentUser.policyHolderInfo.StreetAddress ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.StreetAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        City: accidentUser.policyHolderInfo.City ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.City ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        State: accidentUser.policyHolderInfo.State ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.State ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        ZipCode: accidentUser.policyHolderInfo.ZipCode ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.ZipCode ? true : false


    mandAttributesClone = {
      ...mandAttributesClone,
      policyHolderInfo: {
        ...mandAttributesClone.policyHolderInfo,
        EmailAddress: accidentUser.policyHolderInfo.EmailAddress ? true : false
      }
    }
    if (status) status = accidentUser.policyHolderInfo.EmailAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        FirstName: accidentUser.ownerInfo.FirstName ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.FirstName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        LastName: accidentUser.ownerInfo.LastName ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.LastName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        PhoneNumber: validatePhoneNumber(accidentUser.ownerInfo.PhoneNumber).isValid ? true : false
      }
    }
    if (status) status = validatePhoneNumber(accidentUser.ownerInfo.PhoneNumber).isValid ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        EmailAddress: accidentUser.ownerInfo.EmailAddress ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.EmailAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        StreetAddress: accidentUser.ownerInfo.StreetAddress ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.StreetAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        City: accidentUser.ownerInfo.City ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.City ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        State: accidentUser.ownerInfo.State ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.State ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      ownerInfo: {
        ...mandAttributesClone.ownerInfo,
        ZipCode: accidentUser.ownerInfo.ZipCode ? true : false
      }
    }
    if (status) status = accidentUser.ownerInfo.ZipCode ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        StreetAddress: accidentUser.lossInformation.StreetAddress ? true : false
      }
    }
    if (status) status = accidentUser.lossInformation.StreetAddress ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        City: accidentUser.lossInformation.City ? true : false
      }
    }
    if (status) status = accidentUser.lossInformation.City ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        ZipCode: accidentUser.lossInformation.ZipCode ? true : false
      }
    }
    if (status) status = accidentUser.lossInformation.ZipCode ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      lossInformation: {
        ...mandAttributesClone.lossInformation,
        descriptionOfAccident: accidentUser.lossInformation.descriptionOfAccident ? true : false
      }
    }
    if (status) status = accidentUser.lossInformation.descriptionOfAccident ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        FirstName: accidentUser.cureDriverInfo.FirstName ? true : false
      }
    }
    if (status) status = accidentUser.cureDriverInfo.FirstName ? true : false

    mandAttributesClone = {
      ...mandAttributesClone,
      cureDriverInfo: {
        ...mandAttributesClone.cureDriverInfo,
        LastName: accidentUser.cureDriverInfo.LastName ? true : false
      }
    }
    if (status) status = accidentUser.cureDriverInfo.LastName ? true : false

    if (accidentUser.anyOtherVehiclesInvolved === 'Yes') {
      const clonedVehicles = accidentUser.vehicleInvolved ? [...accidentUser.vehicleInvolved] : []
      clonedVehicles.map((vehicle, index) => {
        mandAttributesClone.vehicleInvolved[index] = { cureOwnerInfo: {} }
        mandAttributesClone.vehicleInvolved[index].cureOwnerInfo.FirstName = vehicle.cureOwnerInfo.FirstName ? true : false
        mandAttributesClone.vehicleInvolved[index].cureOwnerInfo.LastName = vehicle.cureOwnerInfo.LastName ? true : false
        mandAttributesClone.vehicleInvolved[index].cureOwnerInfo.StreetAddress = vehicle.cureOwnerInfo.StreetAddress ? true : false
        mandAttributesClone.vehicleInvolved[index].cureOwnerInfo.City = vehicle.cureOwnerInfo.City ? true : false
        mandAttributesClone.vehicleInvolved[index].cureOwnerInfo.ZipCode = vehicle.cureOwnerInfo.ZipCode ? true : false
      })

      const vehicleStatus = clonedVehicles.every(
        injuries => injuries.cureOwnerInfo.FirstName && injuries.cureOwnerInfo.LastName && injuries.cureOwnerInfo.StreetAddress && injuries.cureOwnerInfo.City && injuries.cureOwnerInfo.ZipCode
      )
      if (!vehicleStatus) status = false
    }

    if (accidentUser.wereThereAnyPassengersInVehicle === 'Yes') {
      const clonedPassengers = accidentUser.passengersInvehiclesLists ? [...accidentUser.passengersInvehiclesLists] : []
      clonedPassengers.map((passengers, index) => {
        mandAttributesClone.passengersInvehiclesLists[index] = {}
        mandAttributesClone.passengersInvehiclesLists[index].FirstName = passengers.FirstName ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].LastName = passengers.LastName ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].description = passengers.description ? true : false
        mandAttributesClone.passengersInvehiclesLists[index].isPersonInjured = passengers.isPersonInjured ? true : false
      })

      const accidentalStatus = clonedPassengers.every(
        injuries => injuries.FirstName && injuries.LastName && (!injuries.isPersonInjured || injuries.isPersonInjured === "No" || (injuries.isPersonInjured === "Yes" && injuries.description))
      )

      if (!accidentalStatus) status = false
    }

    if (accidentUser.wereThereAnyInjuriesInLoss === 'Yes') {
      const clonedInjuredPassengrs = accidentUser.injuriesInLossLists ? [...accidentUser.injuriesInLossLists] : []

      clonedInjuredPassengrs.map((injuries, index) => {
        mandAttributesClone.injuriesInLossLists[index].FirstName = injuries.FirstName ? true : false
        mandAttributesClone.injuriesInLossLists[index].LastName = injuries.LastName ? true : false
        mandAttributesClone.injuriesInLossLists[index].description = injuries.description ? true : false
      })

      const insuredStatus = clonedInjuredPassengrs.some(
        injuries => injuries.FirstName && injuries.LastName && injuries.description
      )
      if (!insuredStatus) status = false
    }

    mandAttributesClone.anyOtherVehiclesInvolved = accidentUser.anyOtherVehiclesInvolved
    if (mandAttributesClone.anyOtherVehiclesInvolved === "") {
      if (status) status = false
    }

    mandAttributesClone.wereThereAnyInjuriesInLoss = accidentUser.wereThereAnyInjuriesInLoss
    if (mandAttributesClone.wereThereAnyInjuriesInLoss === "") {
      if (status) status = false
    }

    mandAttributesClone.wereThereAnyPassengersInVehicle = accidentUser.wereThereAnyPassengersInVehicle
    if (mandAttributesClone.wereThereAnyInjuriesInLoss === "") {
      if (status) status = false
    }

    if (!accidentAttested) {
      status = false
    }

    setMandatoryAccidentalUser(mandAttributesClone)
    return status
  }

  const handleInsuredSubmit = async values => {
    var reportType = "I am insured with CURE"
    setAlreadySubmitted(true)
    setDisplayBlockedMessage(false)
    setDisplayInsuredMissingFieldMessage(false)
    setShowInsuredSpinner(true)
    const htmlText = buildTable(insuredUser, accidentUser, selectedClaim)
    const validationResponse = validateInsuredUserData(insuredUser)
    if (validationResponse) {
      const mailObj = {
        subject: `[FNOL Claim Form] - ${insuredUser.policyHolderInfo.PolicyNumber}`,
        content: htmlText
      }

      insuredUser.user["ReportType"] = reportType
      var fnolDataSendResponse = await sendFNOLData(insuredUser)
      if(fnolDataSendResponse.data.Result === "Blocked"){
        setDisplayBlockedMessage(true)
        setShowInsuredSpinner(false)
        scrollToError()
        return
      }
      mailObj["claimID"] = fnolDataSendResponse.data.Result;
      mailObj["reportType"] = reportType

      if (parseInt(fnolDataSendResponse.data.Result) != 0) {
        await sendEmailForClaimsFNOL(mailObj)
      }
      const newWindow = window.open('/claims/fnol-form-result', '_self', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
      setShowInsuredSpinner(false)
    } else {
      setDisplayInsuredMissingFieldMessage(true)
      setShowInsuredSpinner(false)
      scrollToError()
      return false
    }
  }

  const handleAccidentSubmit = async () => {
    var reportType = "I had an accident with a CURE customer"
    setAlreadySubmitted(true)
    setDisplayAccidentMissingFieldMessage(false)
    setDisplayBlockedMessage(false)
    setShowAccidentSpinner(true)
    console.log("####", accidentUser)
    const htmlText = buildTable(insuredUser, accidentUser, selectedClaim)
    const validationResponse = validateAccidentUserData(accidentUser)
    if (validationResponse) {
      const mailObj = {
        subject: `[FNOL Claim Form] - ${accidentUser.policyHolderInfo.PolicyNumber}`,
        content: htmlText
      }
      accidentUser.user["ReportType"] = reportType
      var fnolDataSendResponse = await sendFNOLData(accidentUser)
      if(fnolDataSendResponse.data.Result === "Blocked"){
        setDisplayBlockedMessage(true)
        setShowInsuredSpinner(false)
        scrollToError()
        return
      }
      mailObj["claimID"] = fnolDataSendResponse.data.Result;
      mailObj["reportType"] = reportType

      if (parseInt(fnolDataSendResponse.data.Result) != 0) {
        await sendEmailForClaimsFNOL(mailObj)
      }
      const newWindow = window.open('/claims/fnol-form-result', '_self', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
      setShowAccidentSpinner(false)
    } else {
      setDisplayAccidentMissingFieldMessage(true)
      setShowAccidentSpinner(false)
      scrollToError()
      return false
    }
  }

  const handleAddingPassengersInAccidentInjuries = () => {
    const list = [...accidentUser.passengersInvehiclesLists]
    const mandatoryList = [...mandatoryAccidentalUser.passengersInvehiclesLists]
    list.push({
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      City: '',
      ZipCode: '',
      isPersonInjured: '',
      description: ''
    })
    mandatoryList.push({
      FirstName: false,
      LastName: false,
      description: false
    })
    setAccidentUser({
      ...accidentUser,
      passengersInvehiclesLists: list
    })

    setMandatoryAccidentalUser({
      ...mandatoryAccidentalUser,
      passengersInvehiclesLists: mandatoryList
    })
  }

  const handleAddingAccidentInjuries = () => {
    const list = [...accidentUser.injuriesInLossLists]
    const mandatoryList = [...mandatoryAccidentalUser.injuriesInLossLists]

    list.push({
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      City: '',
      ZipCode: '',
      description: ''
    })
    mandatoryList.push({
      FirstName: false,
      LastName: false,
      description: false
    })
    setAccidentUser({
      ...accidentUser,
      injuriesInLossLists: list
    })

    setMandatoryAccidentalUser({
      ...mandatoryInsuredUser,
      injuriesInLossLists: mandatoryList
    })
  }

  const handleAddingInsuredPassengersInAccidentInjuries = () => {
    const list = [...insuredUser.passengersInvehiclesLists]
    const mandatoryList = [...mandatoryInsuredUser.passengersInvehiclesLists]
    list.push({
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      City: '',
      ZipCode: '',
      isPersonInjured: '',
      description: ''
    })
    mandatoryList.push({
      FirstName: false,
      LastName: false,
      description: false
    })
    setInsuredUser({
      ...insuredUser,
      passengersInvehiclesLists: list
    })
    setMandatoryInsuredUser({
      ...mandatoryInsuredUser,
      passengersInvehiclesLists: mandatoryList
    })
  }

  const handleAddingMultipleVehiclesInfoInjuries = () => {
    const list = [...insuredUser.vehicleInvolved]
    const mandatoryList = [...mandatoryInsuredUser.vehicleInvolved]

    list.push({
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      describeDamage: '',
      ownerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        City: '',
        ZipCode: ''
      }
    })
    setInsuredUser({
      ...insuredUser,
      vehicleInvolved: list
    })
    mandatoryList.push({
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      describeDamage: '',
      ownerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        City: '',
        ZipCode: ''
      }
    })
    setMandatoryInsuredUser({
      ...mandatoryInsuredUser,
      vehicleInvolved: mandatoryList
    })
  }


  const handleAddingMultipleVehiclesInfoAcc = () => {
    const list = [...accidentUser.vehicleInvolved]
    const mandatoryList = [...mandatoryAccidentalUser.vehicleInvolved]

    list.push({
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      describeDamage: '',
      cureOwnerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        City: '',
        ZipCode: ''
      }
    })
    setAccidentUser({
      ...accidentUser,
      vehicleInvolved: list
    })
    mandatoryList.push({
      year: '',
      model: '',
      make: '',
      otherCarrierName: '',
      otherCarrierClaim: '',
      describeProperty: '',
      describeDamage: '',
      cureOwnerInfo: {
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmailAddress: '',
        StreetAddress: '',
        City: '',
        ZipCode: ''
      }
    })
    setMandatoryAccidentalUser({
      ...mandatoryAccidentalUser,
      vehicleInvolved: mandatoryList
    })
  }

  const handleAddingInsuredAccidentInjuries = () => {
    const list = [...insuredUser.injuriesInLossLists]
    const mandatoryList = [...mandatoryInsuredUser.injuriesInLossLists]

    list.push({
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      EmailAddress: '',
      StreetAddress: '',
      City: '',
      ZipCode: '',
      description: ''
    })
    setInsuredUser({
      ...insuredUser,
      injuriesInLossLists: list
    })

    mandatoryList.push({
      FirstName: false,
      LastName: false,
      description: false
    })
    setMandatoryInsuredUser({
      ...mandatoryInsuredUser,
      injuriesInLossLists: mandatoryList
    })
  }

  const deleteItem = index => {
    const list = [...insuredUser.injuriesInLossLists]
    const removedItem = list.splice(index, 1)
    setInsuredUser({
      ...insuredUser,
      injuriesInLossLists: list
    })

    const mandatoryList = [...mandatoryInsuredUser.injuriesInLossLists]
    mandatoryList.splice(index, 1)

    setMandatoryInsuredUser({
      ...mandatoryInsuredUser,
      injuriesInLossLists: mandatoryList
    })
  }

  const deletePassengerItem = index => {
    const list = [...insuredUser.passengersInvehiclesLists]
    const removedItem = list.splice(index, 1)
    setInsuredUser({
      ...insuredUser,
      passengersInvehiclesLists: list
    })
    const mandatoryList = [...mandatoryInsuredUser.passengersInvehiclesLists]
    mandatoryList.splice(index, 1)

    setMandatoryInsuredUser({
      ...mandatoryInsuredUser,
      passengersInvehiclesLists: mandatoryList
    })
  }

  const deleteVehicleInfoInsItem = index => {
    const list = [...insuredUser.vehicleInvolved]
    const removedItem = list.splice(index, 1)
    setInsuredUser({
      ...insuredUser,
      vehicleInvolved: list
    })
  }

  const deleteVehicleInfoAccItem = index => {
    const list = [...accidentUser.vehicleInvolved]
    const removedItem = list.splice(index, 1)
    setAccidentUser({
      ...accidentUser,
      vehicleInvolved: list
    })
  }

  const deleteAccidentalItem = index => {
    const list = [...accidentUser.injuriesInLossLists]
    const removedItem = list.splice(index, 1)
    setAccidentUser({
      ...accidentUser,
      injuriesInLossLists: list
    })

    const mandatoryList = [...mandatoryAccidentalUser.injuriesInLossLists]
    mandatoryList.splice(index, 1)

    setMandatoryAccidentalUser({
      ...mandatoryAccidentalUser,
      injuriesInLossLists: mandatoryList
    })
  }

  const deleteAccidentalPassengerItem = index => {
    const list = [...accidentUser.passengersInvehiclesLists]
    const removedItem = list.splice(index, 1)
    setAccidentUser({
      ...accidentUser,
      passengersInvehiclesLists: list
    })

    const mandatoryList = [...mandatoryAccidentalUser.passengersInvehiclesLists]
    mandatoryList.splice(index, 1)

    setMandatoryAccidentalUser({
      ...mandatoryAccidentalUser,
      passengersInvehiclesLists: mandatoryList
    })
  }

  const updatePassengerInVehicle = (value, field, index) => {
    const clonedList = [...insuredUser.passengersInvehiclesLists]
    clonedList[index][field] = value
    setInsuredUser({
      ...insuredUser,
      passengersInvehiclesLists: clonedList
    })
  }

  const updateVehicleInvolvedInVehicle = (value, field, index) => {
    const clonedList = [...insuredUser.vehicleInvolved]
    if (field.includes("ownerInfo")) {
      if (field == 'ownerInfo.FirstName') {
        clonedList[index].ownerInfo.FirstName = value

      } else if (field == 'ownerInfo.FirstName') {
        clonedList[index].ownerInfo.FirstName = value

      } else if (field == 'ownerInfo.LastName') {
        clonedList[index].ownerInfo.LastName = value

      } else if (field == 'ownerInfo.EmailAddress') {
        clonedList[index].ownerInfo.EmailAddress = value

      } else if (field == 'ownerInfo.PhoneNumber') {
        clonedList[index].ownerInfo.PhoneNumber = value

      } else if (field == 'ownerInfo.StreetAddress') {
        clonedList[index].ownerInfo.StreetAddress = value

      } else if (field == 'ownerInfo.ApartmentNo') {
        clonedList[index].ownerInfo.ApartmentNo = value

      } else if (field == 'ownerInfo.City') {
        clonedList[index].ownerInfo.City = value

      } else if (field == 'ownerInfo.State') {
        clonedList[index].ownerInfo.State = value

      } else if (field == 'ownerInfo.ZipCode') {
        clonedList[index].ownerInfo.ZipCode = value
      }
    } else {
      clonedList[index][field] = value
    }

    setInsuredUser({
      ...insuredUser,
      vehicleInvolved: clonedList
    })
  }

  const updateVehicleInvolvedAccVehicle = (value, field, index) => {
    const clonedList = [...accidentUser.vehicleInvolved]
    if (field == 'cureOwnerInfo.FirstName') {
      clonedList[index]['cureOwnerInfo'].FirstName = value

    } else if (field == 'cureOwnerInfo.FirstName') {
      clonedList[index]['cureOwnerInfo'].FirstName = value

    } else if (field == 'cureOwnerInfo.LastName') {
      clonedList[index]['cureOwnerInfo'].LastName = value

    } else if (field == 'cureOwnerInfo.EmailAddress') {
      clonedList[index]['cureOwnerInfo'].EmailAddress = value

    } else if (field == 'cureOwnerInfo.PhoneNumber') {
      clonedList[index]['cureOwnerInfo'].PhoneNumber = value

    } else if (field == 'cureOwnerInfo.StreetAddress') {
      clonedList[index]['cureOwnerInfo'].StreetAddress = value

    } else if (field == 'cureOwnerInfo.ApartmentNo') {
      clonedList[index]['cureOwnerInfo'].ApartmentNo = value

    } else if (field == 'cureOwnerInfo.State') {
      clonedList[index]['cureOwnerInfo'].State = value
    } else if (field == 'cureOwnerInfo.City') {
      clonedList[index]['cureOwnerInfo'].City = value
    } else if (field == 'cureOwnerInfo.ZipCode') {
      clonedList[index]['cureOwnerInfo'].ZipCode = value
    } else {
      clonedList[index][field] = value
    }

    setAccidentUser({
      ...accidentUser,
      vehicleInvolved: clonedList
    })
  }

  const updateInsuredInVehicle = (value, field, index) => {
    const clonedList = [...insuredUser.injuriesInLossLists]
    clonedList[index][field] = value
    setInsuredUser({
      ...insuredUser,
      injuriesInLossLists: clonedList
    })
  }

  const updateAcciedentalInVehicle = (value, field, index) => {
    const clonedList = [...accidentUser.injuriesInLossLists]
    clonedList[index][field] = value
    setAccidentUser({
      ...accidentUser,
      injuriesInLossLists: clonedList
    })
  }

  const updateAccidentalPassengerInInVehicle = (value, field, index) => {
    const clonedList = [...accidentUser.passengersInvehiclesLists]
    clonedList[index][field] = value
    setAccidentUser({
      ...accidentUser,
      passengersInvehiclesLists: clonedList
    })
  }

  const validateEmail = userDetails => {
    const {
      user: { EmailAddress }
    } = userDetails
    const regEx = /\S+@\S+\.\S+/

    if (EmailAddress.length > 0 && regEx.test(EmailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = PhoneNumber => {

    const updatedNumber = PhoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateDate = Date => {
    const updatedDate = Date.replaceAll('/', '').replaceAll('_', '')
    if (updatedDate.length < 8) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateBasicFormData = userDetails => {
    const {
      user: { FirstName, LastName, PhoneNumber, EmailAddress },
      lossInfo: { DateOfLoss }
    } = userDetails

    if (FirstName && LastName && PhoneNumber && EmailAddress && DateOfLoss) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateFields = userDetails => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(userDetails)
    if (initialResponse.isValid) {
      const emailValidationResponse = validateEmail(userDetails)
      const phoneValidationResponse = validatePhoneNumber(userDetails.user.PhoneNumber)

      if (emailValidationResponse.isValid && phoneValidationResponse.isValid) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const scrollToError = () => {
    //Scrolls to invalid fields
    var errors = document.querySelector('.error-border, .error-text')
    if (errors)
      errors.scrollIntoView()
  }

  const setErrorEvt = (validateFunc) => {
    //Add events to revalidate every input
    var errors = document.querySelectorAll('.error-border, .error-text+div span input')
    if (errors.length > 0) {
      errors.forEach((val) => {
        val.removeEventListener("blur", (e) => {
          validateFunc()
        })
      })
      errors.forEach((val) => {
        val.addEventListener("blur", (e) => {
          validateFunc()
        })
      })
    }
  }

  const onBlurAccident = () => {
    const error = document.querySelectorAll('.error-border, .error-text, .error-text+div span input')
    if (error.length || alreadySubmitted) {
      const validationResponse = validateAccidentUserData(accidentUser)
      if (validationResponse) {
        setDisplayAccidentMissingFieldMessage(false)
      }
    }
  }

  const onBlurInsured = () => {
    const error = document.querySelectorAll('.error-border, .error-text, .error-text+div span input')
    if (error.length || alreadySubmitted) {
      const validationResponse = validateInsuredUserData(insuredUser)
      if (validationResponse) {
        setDisplayInsuredMissingFieldMessage(false)
      }
    }
  }
  return (
    <>
      <SEO 
        title={"Report a Claim | CURE Auto Insurance"} 
        description={"Quickly report your insurance claim with CURE auto insurance. Start your FNOL claim process online in minutes."} 
        url={"/claims/fnol-form"}
      />
      <EmptyHeaderHero title="Report a Claim" />
      <Row className={`${FNOLStyle["claims-selection"]}`}>
        <div className={`${FNOLStyle["claims-wrapper"]}`}>
          <Col xl={{ span: 11 }} xs={{ span: 24 }}>
            <h5>Who is reporting the claim today:</h5>
          </Col>
          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
            <Select
              onChange={event => setSelectedClaim(event)}
              placeholder="Select"
              value={selectedClaim || undefined}
            >
              {CLAIMS_OPTIONS.map((obj, index) => (
                <Option className={`${FNOLStyle["claims-option"]}`} key={index} value={obj.id}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Col>
          {selectedClaim && selectedClaim === 'i-am-insured-with-cure' && (
            <Col xl={{ span: 24 }} xs={{ span: 24 }} className={`empty-header-hero ${FNOLStyle.myAccountLinkContainer}`}>
              <hr className={FNOLStyle.myAccountLinkRuler}/>
              <h5 className={FNOLStyle.myAccountLinkText}>Log into <a href="/my-account"><u>My Account</u></a> to report your claim or complete form below to continue as a guest.</h5>
              <hr className={FNOLStyle.myAccountLinkRuler}/>
            </Col>
          )}
          {selectedClaim && selectedClaim === 'i-am-insured-with-cure' && (
            <Form autoComplete="off">
              
              <Card className={`${FNOLStyle["register-card"]}`}>
                <h5>Your Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.user.hasOwnProperty('FirstName')
                        ? !mandatoryInsuredUser.user.FirstName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => updateUserTextFields(event.target.value, 'insured', 'FirstName')}
                      placeholder="First Name*"
                      value={insuredUser.user.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.user.hasOwnProperty('LastName')
                        ? !mandatoryInsuredUser.user.LastName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => updateUserTextFields(event.target.value, 'insured', 'LastName')}
                      placeholder="Last Name*"
                      value={insuredUser.user.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryInsuredUser.user.hasOwnProperty('PhoneNumber')
                        ? !mandatoryInsuredUser.user.PhoneNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const phoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        updateUserTextFields(phoneNumber, 'insured', 'PhoneNumber')
                      }}
                      placeholder="Phone Number*"
                      value={insuredUser.user.PhoneNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.user.hasOwnProperty('EmailAddress')
                        ? !mandatoryInsuredUser.user.EmailAddress
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => updateUserTextFields(event.target.value, 'insured', 'EmailAddress')}
                      placeholder="Email Address*"
                      value={insuredUser.user.EmailAddress}
                    />
                  </Col>
                </Row>
                <h5>Loss Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["dob"]} ${FNOLStyle["input-text"]} ${mandatoryInsuredUser.lossInfo.hasOwnProperty('DateOfLoss')
                        ? !mandatoryInsuredUser.lossInfo.DateOfLoss
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="99/99/9999"
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInfo }
                        clonedData.DateOfLoss = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInfo: clonedData
                        })
                      }}
                      placeholder="Date of Loss mm/dd/yyyy*"
                      value={insuredUser.lossInfo.DateOfLoss}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    {/* <TimePicker
                      className={`${FNOLStyle["input-text"]}`}
                      format="HH:mm"
                      placeholder="Time of Loss hh:mm AM/PM"
                      onChange={(time, timeString) => {
                        const clonedData = { ...insuredUser.lossInfo }
                        clonedData.TimeOfLoss = timeString
                        setInsuredUser({
                          ...insuredUser,
                          lossInfo: clonedData
                        })
                      }}
                      value={dayjs(insuredUser.lossInfo.TimeOfLoss, 'HH:mm')}
                    /> */}
                    <TimePickerCustom
                      showSecond={false}
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Time of Loss hh:mm AM/PM"
                      defaultValue={insuredUser.lossInfo.TimeOfLoss}
                      format={dd_format}
                      onChange={(value) => {
                        const clonedData = { ...insuredUser.lossInfo }
                        clonedData.TimeOfLoss = value
                        setInsuredUser({
                          ...insuredUser,
                          lossInfo: clonedData
                        })
                      }}
                      use12Hours
                    />
                  </Col>
                </Row>
                <h5>CURE Policyholder Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.FirstName = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="First Name"
                      value={insuredUser.policyHolderInfo.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.LastName = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Last Name"
                      value={insuredUser.policyHolderInfo.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.policyHolderInfo.hasOwnProperty('PolicyNumber')
                        ? !mandatoryInsuredUser.policyHolderInfo.PolicyNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.PolicyNumber = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Policy Number*"
                      value={insuredUser.policyHolderInfo.PolicyNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      className={`${FNOLStyle["input-text"]}`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.PhoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Phone Number"
                      value={insuredUser.policyHolderInfo.PhoneNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.StreetAddress = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Street Address"
                      value={insuredUser.policyHolderInfo.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.ApartmentNo = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Apartment #"
                      value={insuredUser.policyHolderInfo.ApartmentNo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="City"
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.City = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      value={insuredUser.policyHolderInfo.City}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                  <Select
                    showSearch          
                    autoComplete="off"  
                    placeholder="State"
                    value={insuredUser.policyHolderInfo.State || undefined}
                    className={`${FNOLStyle["input-text-2"]}`}
                    onChange={value => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.State = value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                  >
                    {STATE_OPTIONS.map((obj, index) => (
                      <Select.Option
                        key={index}
                        value={obj.value}
                        label={obj.label}
                      >
                        {obj.label}
                      </Select.Option>
                    ))}
                  </Select>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Zip Code"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.ZipCode = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      value={insuredUser.policyHolderInfo.ZipCode}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.policyHolderInfo }
                        clonedData.EmailAddress = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Email Address"
                      value={insuredUser.policyHolderInfo.EmailAddress}
                    />
                  </Col>
                </Row>
                <h5>CURE Vehicle Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInfo.hasOwnProperty('year')
                        ? !mandatoryInsuredUser.vehicleInfo.year
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Year*"
                      maxLength="4"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.year = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.year}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInfo.hasOwnProperty('make')
                        ? !mandatoryInsuredUser.vehicleInfo.make
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Make*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.make = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.make}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInfo.hasOwnProperty('model')
                        ? !mandatoryInsuredUser.vehicleInfo.model
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Model*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.model = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.model}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="VIN"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.vin = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.vin}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Who is the owner of this vehicle?"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.owner = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.owner}
                    />
                  </Col>

                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Who is the vehicle registered to?"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.registeredTo = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.registeredTo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      placeholder="Describe the damage to the vehicle"
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.describeDamage = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.describeDamage}
                    />
                  </Col>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Row>
                      <Col xl={{ span: 12 }} xs={{ span: 24 }}>
                        {/*  */}
                        <Text className={`${FNOLStyle["form-label"]}`} style={{ fontSize: "19px" }}>Did the airbags deploy? </Text>
                        <Radio.Group
                          onChange={event => {
                            const clonedData = { ...insuredUser.vehicleInfo }
                            clonedData.isAirbagDeployed = event.target.value
                            setInsuredUser({
                              ...insuredUser,
                              vehicleInfo: clonedData
                            })
                          }}
                          value={insuredUser.vehicleInfo.isAirbagDeployed}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                        {/*  */}
                      </Col>
                      <Col xl={{ span: 12 }} xs={{ span: 24 }}>
                        {/*  */}
                        <Text className={`${FNOLStyle["form-label"]}`} style={{ fontSize: "19px" }}>Is the vehicle still drivable? </Text>
                        <Radio.Group
                          onChange={event => {
                            const clonedData = { ...insuredUser.vehicleInfo }
                            clonedData.isDrivable = event.target.value
                            setInsuredUser({
                              ...insuredUser,
                              vehicleInfo: clonedData
                            })
                          }}
                          value={insuredUser.vehicleInfo.isDrivable}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                        {/*  */}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 12 }}>
                      <Col xl={{ span: 12 }} xs={{ span: 24 }}>
                        {/*  */}
                        <Text className={`${FNOLStyle["form-label"]}`} style={{ fontSize: "19px" }}>Was the vehicle towed from the scene?{` `}</Text>
                        <Radio.Group
                          onChange={event => {
                            const clonedData = { ...insuredUser.vehicleInfo }
                            clonedData.isTowed = event.target.value
                            setInsuredUser({
                              ...insuredUser,
                              vehicleInfo: clonedData
                            })
                          }}
                          value={insuredUser.vehicleInfo.isTowed}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                        {/*  */}
                      </Col>
                      {insuredUser.vehicleInfo.isTowed === 'Yes' && <Col xl={{ span: 12 }} xs={{ span: 24 }}>
                        <Input
                          placeholder="If Yes, where?*"
                          onBlur={onBlurInsured}
                          className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInfo.hasOwnProperty('towedReason')
                            ? !mandatoryInsuredUser.vehicleInfo.towedReason
                              ? 'error-border'
                              : ''
                            : ''
                            }`}
                          onChange={event => {
                            const clonedData = { ...insuredUser.vehicleInfo }
                            clonedData.towedReason = event.target.value
                            setInsuredUser({
                              ...insuredUser,
                              vehicleInfo: clonedData
                            })
                          }}
                          value={insuredUser.vehicleInfo.towedReason}
                        />
                      </Col>}
                    </Row>
                    <Row style={{ marginTop: 12 }}>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        {/*  */}
                        <Text className={`${FNOLStyle["form-label"]}`} style={{ fontSize: "19px" }}>Was there any prior damage to the vehicle before the accident?{` `}</Text>
                        <Radio.Group
                          onChange={event => {
                            const clonedData = { ...insuredUser.vehicleInfo }
                            clonedData.isDamaged = event.target.value
                            setInsuredUser({
                              ...insuredUser,
                              vehicleInfo: clonedData
                            })
                          }}
                          value={insuredUser.vehicleInfo.isDamaged}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                        {/*  */}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row>
                  {insuredUser.vehicleInfo.isDamaged === 'Yes' && <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      placeholder="Please describe the prior damage to the vehicle before the accident."
                      onChange={event => {
                        const clonedData = { ...insuredUser.vehicleInfo }
                        clonedData.priorDamage = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={insuredUser.vehicleInfo.priorDamage}
                    />
                  </Col>
                  }
                </Row>
                <h5>CURE Driver Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.cureDriverInfo.hasOwnProperty('FirstName')
                        ? !mandatoryInsuredUser.cureDriverInfo.FirstName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.FirstName = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="First Name*"
                      value={insuredUser.cureDriverInfo.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.cureDriverInfo.hasOwnProperty('LastName')
                        ? !mandatoryInsuredUser.cureDriverInfo.LastName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.LastName = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Last Name*"
                      value={insuredUser.cureDriverInfo.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.EmailAddress = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Email Address"
                      value={insuredUser.cureDriverInfo.EmailAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      className={`${FNOLStyle["input-text"]}`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.PhoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Phone Number"
                      value={insuredUser.cureDriverInfo.PhoneNumber}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.cureDriverInfo.hasOwnProperty('StreetAddress')
                        ? !mandatoryInsuredUser.cureDriverInfo.StreetAddress
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.StreetAddress = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Street Address*"
                      value={insuredUser.cureDriverInfo.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`input-text`}
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.ApartmentNo = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Apartment #"
                      value={insuredUser.cureDriverInfo.ApartmentNo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.cureDriverInfo.hasOwnProperty('City')
                        ? !mandatoryInsuredUser.cureDriverInfo.City
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="City*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.City = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      value={insuredUser.cureDriverInfo.City}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                  <Select
                    showSearch          
                    autoComplete="off"  
                    onBlur={onBlurInsured}
                    placeholder="State*"
                    value={insuredUser.cureDriverInfo.State || undefined}
                    className={`${FNOLStyle["input-text-2"]}`}
                    onChange={value => {
                      const clonedData = { ...insuredUser.cureDriverInfo }
                      clonedData.State = value
                      setInsuredUser({
                        ...insuredUser,
                        cureDriverInfo: clonedData
                      })
                    }}
                    optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                  >
                    {STATE_OPTIONS.map((obj, index) => (
                      <Select.Option
                        key={index}
                        value={obj.value}
                        label={obj.label}
                      >
                        {obj.label}
                      </Select.Option>
                    ))}
                  </Select>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.cureDriverInfo.hasOwnProperty('ZipCode')
                        ? !mandatoryInsuredUser.cureDriverInfo.ZipCode
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Zip Code*"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.ZipCode = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      value={insuredUser.cureDriverInfo.ZipCode}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Relationship to the Policyholder"
                      onChange={event => {
                        const clonedData = { ...insuredUser.cureDriverInfo }
                        clonedData.relationToPolicyholder = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      value={insuredUser.cureDriverInfo.relationToPolicyholder}
                    />
                  </Col>
                </Row>

                <h5>Loss Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.lossInformation.hasOwnProperty('StreetAddress')
                        ? !mandatoryInsuredUser.lossInformation.StreetAddress
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Street Address*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInformation }
                        clonedData.StreetAddress = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={insuredUser.lossInformation.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.lossInformation.hasOwnProperty('City')
                        ? !mandatoryInsuredUser.lossInformation.City
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="City*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInformation }
                        clonedData.City = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={insuredUser.lossInformation.City}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurInsured}
                      className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.lossInformation.hasOwnProperty('ZipCode')
                        ? !mandatoryInsuredUser.lossInformation.ZipCode
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Zip Code*"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInformation }
                        clonedData.ZipCode = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={insuredUser.lossInformation.ZipCode}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Text style={{ fontSize: "19px" }}>Police contacted? {`  `}</Text>
                    <Radio.Group
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInformation }
                        clonedData.policeContacted = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={insuredUser.lossInformation.policeContacted}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      onBlur={onBlurInsured}
                      className={`${mandatoryInsuredUser.lossInformation.hasOwnProperty('descriptionOfAccident')
                        ? !mandatoryInsuredUser.lossInformation.descriptionOfAccident
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Description of accident*"
                      onChange={event => {
                        const clonedData = { ...insuredUser.lossInformation }
                        clonedData.descriptionOfAccident = event.target.value
                        setInsuredUser({
                          ...insuredUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={insuredUser.lossInformation.descriptionOfAccident}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryInsuredUser.hasOwnProperty('anyOtherVehiclesInvolved')
                      ? !mandatoryInsuredUser.anyOtherVehiclesInvolved
                        ? 'error-text'
                        : ''
                      : ''}`}
                      style={{ fontSize: "19px" }}>
                      Were there any other vehicles or property damaged in the loss?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurInsured}
                      onChange={event => {
                        setInsuredUser({
                          ...insuredUser,
                          anyOtherVehiclesInvolved: event.target.value
                        })
                      }}
                      value={insuredUser.anyOtherVehiclesInvolved}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>

                {insuredUser.anyOtherVehiclesInvolved === 'Yes' && (
                  <>
                    {
                      insuredUser.vehicleInvolved.map((value, index) => {
                        return <div key={index}>
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <Divider />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                              <Input
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Year"
                                maxLength="4"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'year', index)}
                                value={value['year']}
                                defaultValue={value['year']}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Make"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'make', index)}
                                value={value['make']}
                                defaultValue={value['make']}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Model"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'model', index)}
                                value={value['model']}
                                defaultValue={value['model']}
                              />
                            </Col>
                            {insuredUser.vehicleInvolved.length > 1 && (
                              <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                                <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteVehicleInfoInsItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Other carrier name"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'otherCarrierName', index)}
                                value={value['otherCarrierName']}
                                defaultValue={value['otherCarrierName']}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Other carrier policy #"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'otherCarrierClaim', index)}
                                value={value['otherCarrierClaim']}
                                defaultValue={value['otherCarrierClaim']}
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <TextArea
                                style={{ fontSize: "19px", border: "1px solid #376998" }}
                                rows={4}
                                placeholder="Describe the vehicle or property damage"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'describeProperty', index)}
                                value={value['describeProperty']}
                                defaultValue={value['describeProperty']}
                              />
                            </Col>
                          </Row>
                          <h5>Owner Name and Address</h5>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                placeholder="First Name*"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInvolved[index]?.ownerInfo?.hasOwnProperty('FirstName')
                                  ? !mandatoryInsuredUser.vehicleInvolved[index].ownerInfo.FirstName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.FirstName', index)}
                                value={value.ownerInfo.FirstName}
                                defaultValue={value.ownerInfo.FirstName}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                placeholder="Last Name*"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.vehicleInvolved[index]?.ownerInfo?.hasOwnProperty('LastName')
                                  ? !mandatoryInsuredUser.vehicleInvolved[index].ownerInfo.LastName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.LastName', index)}
                                value={value.ownerInfo.LastName}
                                defaultValue={value.ownerInfo.LastName}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Email Address"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.EmailAddress', index)}
                                value={value.ownerInfo.EmailAddress}
                                defaultValue={value.ownerInfo.EmailAddress}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <InputMask
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                className={`${FNOLStyle["input-text"]}`}
                                mask="(999) 999-9999"
                                placeholder="Phone Number"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.PhoneNumber', index)}
                                value={value.ownerInfo.PhoneNumber}
                                defaultValue={value.ownerInfo.PhoneNumber}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Street Address"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.StreetAddress', index)}
                                value={value.ownerInfo.StreetAddress}
                                defaultValue={value.ownerInfo.StreetAddress}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Apartment #"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.ApartmentNo', index)}
                                value={value.ownerInfo.ApartmentNo}
                                defaultValue={value.ownerInfo.ApartmentNo}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="City"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.City', index)}
                                value={value.ownerInfo.City}
                                defaultValue={value.ownerInfo.City}
                              />
                            </Col><Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="State"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.State', index)}
                                value={value.ownerInfo.State}
                                defaultValue={value.ownerInfo.State}
                              />
                            </Col>

                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Zip Code"
                                maxLength="5"
                                onChange={event => updateVehicleInvolvedInVehicle(event.target.value, 'ownerInfo.ZipCode', index)}
                                value={value.ownerInfo.ZipCode}
                                defaultValue={value.ownerInfo.ZipCode}
                              />
                            </Col>
                          </Row>
                          <Row>
                            {insuredUser.vehicleInvolved.length > 1 && (
                              <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                                <Button type="danger" shape="round" onClick={() => deleteVehicleInfoInsItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <Divider />
                            </Col>
                          </Row>
                        </div>
                      })
                    }
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <Button
                          type="primary"
                          style={{
                            marginBottom: 16,
                            background: '#294c7c',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                          onClick={handleAddingMultipleVehiclesInfoInjuries}
                        >
                          Add Another Vehicle or Property
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}


                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryInsuredUser.hasOwnProperty('wereThereAnyPassengersInVehicle')
                      ? !mandatoryInsuredUser.wereThereAnyPassengersInVehicle
                        ? 'error-text'
                        : ''
                      : ''}`}
                      style={{ fontSize: "19px" }}>
                      Were there any passengers in your vehicle?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurInsured}
                      onChange={event => {
                        setInsuredUser({
                          ...insuredUser,
                          wereThereAnyPassengersInVehicle: event.target.value
                        })
                      }}
                      value={insuredUser.wereThereAnyPassengersInVehicle}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                {insuredUser.wereThereAnyPassengersInVehicle === 'Yes' && (
                  <>
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <h5>Passengers</h5>
                      </Col>
                    </Row>

                    {insuredUser.passengersInvehiclesLists.map((value, index) => {
                      return (
                        <div key={index}>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser?.passengersInvehiclesLists[index]?.hasOwnProperty('FirstName')
                                  ? !mandatoryInsuredUser.passengersInvehiclesLists[index].FirstName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'FirstName', index)}
                                placeholder="First Name*"
                                value={value['FirstName']}
                                defaultValue={value['FirstName']}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser?.passengersInvehiclesLists[index]?.hasOwnProperty('LastName')
                                  ? !mandatoryInsuredUser.passengersInvehiclesLists[index].LastName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'LastName', index)}
                                placeholder="Last Name*"
                                value={value['LastName']}
                              />
                            </Col>
                            {insuredUser.passengersInvehiclesLists.length > 1 && (
                              <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                                <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deletePassengerItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'EmailAddress', index)}
                                placeholder="Email"
                                value={value['EmailAddress']}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <InputMask
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                                mask="(999) 999-9999"
                                onChange={event => updatePassengerInVehicle(event.target.value, 'PhoneNumber', index)}
                                placeholder="Phone Number"
                                value={value['PhoneNumber']}
                              />
                            </Col>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'StreetAddress', index)}
                                placeholder="Street Address"
                                value={value['StreetAddress']}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'ApartmentNo', index)}
                                placeholder="Apartment #"
                                value={value['ApartmentNo']}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'City', index)}
                                placeholder="City"
                                value={value['City']}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updatePassengerInVehicle(event.target.value, 'State', index)}
                                placeholder="State"
                                value={value['State']}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Zip Code"
                                maxLength="5"
                                onChange={event => updatePassengerInVehicle(event.target.value, 'ZipCode', index)}
                                value={value['ZipCode']}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Text style={{ fontSize: "19px" }}>Was this person injured? {`  `}</Text>
                              <Radio.Group
                                onChange={event =>
                                  updatePassengerInVehicle(event.target.value, 'isPersonInjured', index)
                                }
                                value={value['isPersonInjured']}
                              >
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                              </Radio.Group>
                            </Col>
                          </Row>
                          {value['isPersonInjured'] === 'Yes' && (
                            <Row>
                              <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                                <TextArea
                                  style={{ fontSize: "19px", border: "1px solid #376998" }}
                                  rows={4}
                                  onBlur={onBlurInsured}
                                  className={`${mandatoryInsuredUser?.passengersInvehiclesLists[index]?.hasOwnProperty('description')
                                    ? !mandatoryInsuredUser.passengersInvehiclesLists[index].description
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  placeholder="Description of injury*"
                                  onChange={event => updatePassengerInVehicle(event.target.value, 'description', index)}
                                  value={value['description']}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row>
                            {insuredUser.passengersInvehiclesLists.length > 1 && (
                              <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                                <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deletePassengerItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <Divider />
                            </Col>
                          </Row>
                        </div>
                      )
                    })}
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <Button
                          type="primary"
                          style={{
                            marginBottom: 16,
                            background: '#294c7c',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                          onClick={handleAddingInsuredPassengersInAccidentInjuries}
                        >
                          Add Another Passenger
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryInsuredUser.hasOwnProperty('wereThereAnyInjuriesInLoss')
                      ? !mandatoryInsuredUser.wereThereAnyInjuriesInLoss
                        ? 'error-text'
                        : ''
                      : ''}`}
                      style={{ fontSize: "19px" }}>
                      Was anyone else injured in this loss?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurInsured}
                      onChange={event => {
                        setInsuredUser({
                          ...insuredUser,
                          wereThereAnyInjuriesInLoss: event.target.value
                        })
                      }}
                      value={insuredUser.wereThereAnyInjuriesInLoss}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                {insuredUser.wereThereAnyInjuriesInLoss === 'Yes' && (
                  <>
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <h5>Injured Person</h5>
                      </Col>
                    </Row>

                    {insuredUser.injuriesInLossLists.map((value_, index) => (
                      <Card bordered>
                        <div key={index}>
                          <Row xl>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.injuriesInLossLists[index].hasOwnProperty('FirstName')
                                  ? !mandatoryInsuredUser.injuriesInLossLists[index].FirstName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'FirstName', index)}
                                placeholder="First Name*"
                                value={value_.FirstName}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                onBlur={onBlurInsured}
                                className={`${FNOLStyle["input-text"]} ${mandatoryInsuredUser.injuriesInLossLists[index].hasOwnProperty('LastName')
                                  ? !mandatoryInsuredUser.injuriesInLossLists[index].LastName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'LastName', index)}
                                placeholder="Last Name*"
                                value={value_.LastName}
                              />
                            </Col>
                            {insuredUser.injuriesInLossLists.length > 1 && (
                              <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                                <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'EmailAddress', index)}
                                placeholder="Email"
                                value={value_.EmailAddress}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <InputMask
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                                mask="(999) 999-9999"
                                onChange={event => updateInsuredInVehicle(event.target.value, 'PhoneNumber', index)}
                                placeholder="Phone Number"
                                value={value_.PhoneNumber}
                              />
                            </Col>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'StreetAddress', index)}
                                placeholder="Street Address"
                                value={value_.StreetAddress}
                              />
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'ApartmentNo', index)}
                                placeholder="Apartment #"
                                value={value_.ApartmentNo}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'City', index)}
                                placeholder="City"
                                value={value_.City}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                onChange={event => updateInsuredInVehicle(event.target.value, 'State', index)}
                                placeholder="State"
                                value={value_.State}
                              />
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                              <Input
                                type="tel" pattern="[0-9]*" inputmode="numeric"
                                autoComplete="off"
                                className={`${FNOLStyle["input-text"]}`}
                                placeholder="Zip Code"
                                maxLength="5"
                                onChange={event => updateInsuredInVehicle(event.target.value, 'ZipCode', index)}
                                value={value_.ZipCode}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <TextArea
                                style={{ fontSize: "19px", border: "1px solid #376998" }}
                                rows={4}
                                placeholder="Description of injury*"
                                onChange={event => updateInsuredInVehicle(event.target.value, 'description', index)}
                                value={value_.description}
                                onBlur={onBlurInsured}
                                className={`${mandatoryInsuredUser.injuriesInLossLists[index].hasOwnProperty('description')
                                  ? !mandatoryInsuredUser.injuriesInLossLists[index].description
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                  }`}
                              />
                            </Col>
                          </Row>
                          <Row>
                            {insuredUser.injuriesInLossLists.length > 1 && (
                              <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                                <Button type="danger" shape="round" onClick={() => deleteItem(index)}>
                                  Delete
                                </Button>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <Divider />
                            </Col>
                          </Row>
                          {/* </Row>} */}
                        </div>
                      </Card>
                    ))}
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <Button
                          type="primary"
                          style={{
                            marginBottom: 16,
                            background: '#294c7c',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                          onClick={handleAddingInsuredAccidentInjuries}
                        >
                          Add Injury
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
                <Row style={{ marginBottom: "30px", marginTop: "30px" }}>
                  <Checkbox onMouseLeave={onBlurInsured} onChange={e => { console.log(e); setInsuredAttested(e.target.checked) }} style={{ color: !insuredAttested && alreadySubmitted ? "red" : "unset", fontSize: "19px" }}>I hereby certify that, to the best of my knowledge, the provided information is true and accurate.†</Checkbox>
                </Row>
                {displayInsuredMissingFieldMessage && <Row>
                  <Space>
                    <Text style={{ color: "red", fontSize: "19px" }}>Please complete all required fields.</Text>
                  </Space>
                </Row>}
                {displayBlockedMessage && <Row>
                  <Space>
                    <Text style={{ color: "red", fontSize: "19px" }}>Something went wrong, please call 1-800-535-2873 to start your quote.</Text>
                  </Space>
                </Row>}
                <Row className={`${FNOLStyle["submit-container"]}`}>
                  <Space>
                    <Button className={`${FNOLStyle["register"]} ${FNOLStyle["register-form-button"]}`} onClick={() => handleInsuredSubmit()} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      Submit
                    </Button>
                    {showInsuredSpinner && <Col style={{ paddingBottom: 0 }}><Spin indicator={antIcon} /></Col>}
                  </Space>
                </Row>
                <Row style={{ marginTop: "20px" }}><Paragraph>†The Michigan Department of Insurance and Financial Services defines insurance fraud as providing “false information to an insurance company in order to gain something of value that he or she would not have received if the truth had been told[.]” Under Michigan law, it is unlawful to present to any insurer or agent thereof any oral or written statement knowing that the statement contains any false information concerning any fact material to an application for the issuance of an insurance policy or a claim.{"\n"}</Paragraph></Row>
                <Row><Paragraph>†Pursuant to New Jersey regulations, “Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.”{"\n"}</Paragraph></Row>
                <Row><Paragraph>†Pursuant to Pennsylvania regulations, “Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.”{"\n"}</Paragraph></Row>
              </Card>
            </Form>
          )}
          {selectedClaim && selectedClaim === 'i-had-an-accident-with-a-cure-customer' && (
            <Form autoComplete="off">
              <Card className={`${FNOLStyle["register-card"]}`}>
                <h5>Your Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.user.hasOwnProperty('FirstName')
                        ? !mandatoryAccidentalUser.user.FirstName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="First Name*"
                      onChange={event => updateUserTextFields(event.target.value, 'accidentUser', 'FirstName')}
                      value={accidentUser.user.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.user.hasOwnProperty('LastName')
                        ? !mandatoryAccidentalUser.user.LastName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Last Name*"
                      onChange={event => updateUserTextFields(event.target.value, 'accidentUser', 'LastName')}
                      value={accidentUser.user.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.user.hasOwnProperty('PhoneNumber')
                        ? !mandatoryAccidentalUser.user.PhoneNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const phoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        updateUserTextFields(phoneNumber, 'accidentUser', 'PhoneNumber')
                      }}
                      placeholder="Phone Number*"
                      value={accidentUser.user.PhoneNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.user.hasOwnProperty('EmailAddress')
                        ? !mandatoryAccidentalUser.user.EmailAddress
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => updateUserTextFields(event.target.value, 'accidentUser', 'EmailAddress')}
                      placeholder="Email Address*"
                      value={accidentUser.user.EmailAddress}
                    />
                  </Col>
                </Row>
                <h5>Loss Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["dob"]} ${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.lossInfo.hasOwnProperty('DateOfLoss')
                        ? !mandatoryAccidentalUser.lossInfo.DateOfLoss
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="99/99/9999"
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInfo }
                        clonedData.DateOfLoss = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInfo: clonedData
                        })
                      }}
                      placeholder="Date of Loss mm/dd/yyyy*"
                      value={accidentUser.lossInfo.DateOfLoss}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    {/* <TimePicker
                      className={`${FNOLStyle["input-text"]}`}
                      format="HH:mm"
                      placeholder="Time of Loss hh:mm AM/PM"
                      onChange={(time, timeString) => {
                        const clonedData = { ...accidentUser.lossInfo }
                        clonedData.TimeOfLoss = timeString
                        setAccidentUser({
                          ...accidentUser,
                          lossInfo: clonedData
                        })
                      }}
                      value={dayjs(accidentUser.lossInfo.TimeOfLoss, 'HH:mm')}
                    /> */}
                    <TimePickerCustom
                      showSecond={false}
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Time of Loss hh:mm AM/PM"
                      defaultValue={accidentUser.lossInfo.TimeOfLoss}
                      format={dd_format}
                      onChange={(value) => {
                        const clonedData = { ...accidentUser.lossInfo }
                        clonedData.TimeOfLoss = value
                        setAccidentUser({
                          ...accidentUser,
                          lossInfo: clonedData
                        })
                      }}
                      use12Hours
                    />
                  </Col>
                </Row>
                <h5>CURE Policyholder Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('FirstName')
                        ? !mandatoryAccidentalUser.policyHolderInfo.FirstName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.FirstName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="First Name*"
                      value={accidentUser.policyHolderInfo.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('LastName')
                        ? !mandatoryAccidentalUser.policyHolderInfo.LastName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.LastName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Last Name*"
                      value={accidentUser.policyHolderInfo.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('PolicyNumber')
                        ? !mandatoryAccidentalUser.policyHolderInfo.PolicyNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.PolicyNumber = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Policy Number*"
                      value={accidentUser.policyHolderInfo.PolicyNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('PhoneNumber')
                        ? !mandatoryAccidentalUser.policyHolderInfo.PhoneNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.PhoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Phone Number*"
                      value={accidentUser.policyHolderInfo.PhoneNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('StreetAddress')
                        ? !mandatoryAccidentalUser.policyHolderInfo.StreetAddress
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.StreetAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Street Address*"
                      value={accidentUser.policyHolderInfo.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.ApartmentNo = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Apartment #"
                      value={accidentUser.policyHolderInfo.ApartmentNo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('City')
                        ? !mandatoryAccidentalUser.policyHolderInfo.City
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="City*"
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.City = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      value={accidentUser.policyHolderInfo.City}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                  <Select
                    showSearch          
                    autoComplete="off"  
                    onBlur={onBlurAccident}
                    placeholder="State*"
                    value={accidentUser.policyHolderInfo.State || undefined}
                    className={`${FNOLStyle["input-text-2"]}`}
                    onChange={value => {
                      const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.State = value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                    }}
                    optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                  >
                    {STATE_OPTIONS.map((obj, index) => (
                      <Select.Option
                        key={index}
                        value={obj.value}
                        label={obj.label}
                      >
                        {obj.label}
                      </Select.Option>
                    ))}
                  </Select>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('ZipCode')
                        ? !mandatoryAccidentalUser.policyHolderInfo.ZipCode
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Zip Code*"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.ZipCode = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      value={accidentUser.policyHolderInfo.ZipCode}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.policyHolderInfo.hasOwnProperty('EmailAddress')
                        ? !mandatoryAccidentalUser.policyHolderInfo.EmailAddress
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.policyHolderInfo }
                        clonedData.EmailAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          policyHolderInfo: clonedData
                        })
                      }}
                      placeholder="Email Address*"
                      value={accidentUser.policyHolderInfo.EmailAddress}
                    />
                  </Col>
                </Row>
                <h5>Your Vehicle Information</h5>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Year"
                      maxLength="4"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.year = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.year}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Make"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.make = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.make}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Model"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.model = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.model}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Carrier name"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.carrierName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.carrierName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Carrier Policy #"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.carrierClaimNo = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.carrierClaimNo}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      placeholder="Describe the vehicle or property damage"
                      onChange={event => {
                        const clonedData = { ...accidentUser.vehicleInfo }
                        clonedData.describeProperty = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          vehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.vehicleInfo.describeProperty}
                    />
                  </Col>
                </Row>
                <h5>Owner Name and Address</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('FirstName')
                        ? !mandatoryAccidentalUser.ownerInfo.FirstName
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.FirstName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="First Name*"
                      value={accidentUser?.ownerInfo?.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('LastName')
                        ? !mandatoryAccidentalUser.ownerInfo.LastName
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.LastName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="Last Name*"
                      value={accidentUser?.ownerInfo?.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('EmailAddress')
                        ? !mandatoryAccidentalUser.ownerInfo.EmailAddress
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.EmailAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="Email Address*"
                      value={accidentUser?.ownerInfo?.EmailAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('PhoneNumber')
                        ? !mandatoryAccidentalUser.ownerInfo.PhoneNumber
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.PhoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="Phone Number*"
                      value={accidentUser?.ownerInfo?.PhoneNumber}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('StreetAddress')
                        ? !mandatoryAccidentalUser.ownerInfo.StreetAddress
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.StreetAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="Street Address*"
                      value={accidentUser?.ownerInfo?.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]}`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.ApartmentNo = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      placeholder="Apartment #"
                      value={accidentUser?.ownerInfo?.ApartmentNo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('City')
                        ? !mandatoryAccidentalUser.ownerInfo.City
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="City*"
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.City = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      value={accidentUser?.ownerInfo?.City}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('State')
                        ? !mandatoryAccidentalUser.ownerInfo.State
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="State*"
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.State = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      value={accidentUser?.ownerInfo?.State}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]} ${mandatoryAccidentalUser.ownerInfo.hasOwnProperty('ZipCode')
                        ? !mandatoryAccidentalUser.ownerInfo.ZipCode
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Zip Code*"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...accidentUser.ownerInfo }
                        clonedData.ZipCode = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          ownerInfo: clonedData
                        })
                      }}
                      value={accidentUser?.ownerInfo?.ZipCode}
                    />
                  </Col>
                </Row>
                <h5>Loss Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.lossInformation.hasOwnProperty('StreetAddress')
                        ? !mandatoryAccidentalUser.lossInformation.StreetAddress
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Street Address*"
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInformation }
                        clonedData.StreetAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={accidentUser.lossInformation.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.lossInformation.hasOwnProperty('City')
                        ? !mandatoryAccidentalUser.lossInformation.City
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="City*"
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInformation }
                        clonedData.City = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={accidentUser.lossInformation.City}
                    />
                  </Col>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.lossInformation.hasOwnProperty('ZipCode')
                        ? !mandatoryAccidentalUser.lossInformation.ZipCode
                          ? !alreadySubmitted ? '' : 'error-border'
                          : ''
                        : ''
                        }`}
                      placeholder="Zip Code*"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInformation }
                        clonedData.ZipCode = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={accidentUser.lossInformation.ZipCode}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Text style={{ fontSize: "19px" }}>Police contacted? {`  `}</Text>
                    <Radio.Group
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInformation }
                        clonedData.policeContacted = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={accidentUser.lossInformation.policeContacted}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      placeholder="Description of accident*"
                      onBlur={onBlurAccident}
                      className={`${mandatoryAccidentalUser.lossInformation.hasOwnProperty('descriptionOfAccident')
                        ? !mandatoryAccidentalUser.lossInformation.descriptionOfAccident
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.lossInformation }
                        clonedData.descriptionOfAccident = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          lossInformation: clonedData
                        })
                      }}
                      value={accidentUser.lossInformation.descriptionOfAccident}
                    />
                  </Col>
                </Row>
                <h5>CURE Vehicle Information</h5>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Year"
                      maxLength="4"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureVehicleInfo }
                        clonedData.year = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureVehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureVehicleInfo.year}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Make"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureVehicleInfo }
                        clonedData.make = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureVehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureVehicleInfo.make}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]}`}
                      placeholder="Model"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureVehicleInfo }
                        clonedData.model = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureVehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureVehicleInfo.model}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <TextArea
                      style={{ fontSize: "19px", border: "1px solid #376998" }}
                      rows={4}
                      placeholder="Describe Damage"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureVehicleInfo }
                        clonedData.describeProperty = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureVehicleInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureVehicleInfo.describeProperty}
                    />
                  </Col>
                </Row>
                <h5>CURE Driver Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.cureDriverInfo.hasOwnProperty('FirstName')
                        ? !mandatoryAccidentalUser.cureDriverInfo.FirstName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.FirstName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="First Name*"
                      value={accidentUser.cureDriverInfo.FirstName}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      onBlur={onBlurAccident}
                      className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.cureDriverInfo.hasOwnProperty('LastName')
                        ? !mandatoryAccidentalUser.cureDriverInfo.LastName
                          ? 'error-border'
                          : ''
                        : ''
                        }`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.LastName = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Last Name*"
                      value={accidentUser.cureDriverInfo.LastName}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <InputMask
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.PhoneNumber = event.target.value.replace(/[^\w\s]/gi, '').replace(' ', '')
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Phone Number"
                      value={accidentUser.cureDriverInfo.PhoneNumber}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.StreetAddress = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Street Address"
                      value={accidentUser.cureDriverInfo.StreetAddress}
                    />
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.ApartmentNo = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      placeholder="Apartment #"
                      value={accidentUser.cureDriverInfo.ApartmentNo}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                      placeholder="City"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.City = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureDriverInfo.City}
                    />
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                  <Select
                    showSearch          
                    autoComplete="off"  
                    placeholder="State"
                    value={accidentUser.cureDriverInfo.State || undefined} 
                    className={`${FNOLStyle["input-text-2"]} ${FNOLStyle["phone-number"]}`}
                    onChange={value => {
                      const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.State = value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                    }}
                    optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                  >
                    {STATE_OPTIONS.map((obj, index) => (
                      <Select.Option
                        key={index}
                        value={obj.value}
                        label={obj.label}
                      >
                        {obj.label}
                      </Select.Option>
                    ))}
                  </Select>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      type="tel" pattern="[0-9]*" inputmode="numeric"
                      autoComplete="off"
                      className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                      placeholder="Zip Code"
                      maxLength="5"
                      onChange={event => {
                        const clonedData = { ...accidentUser.cureDriverInfo }
                        clonedData.ZipCode = event.target.value
                        setAccidentUser({
                          ...accidentUser,
                          cureDriverInfo: clonedData
                        })
                      }}
                      value={accidentUser.cureDriverInfo.ZipCode}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryAccidentalUser.hasOwnProperty('anyOtherVehiclesInvolved')
                      ? !mandatoryAccidentalUser.anyOtherVehiclesInvolved
                        ? 'error-text'
                        : ''
                      : ''}`} style={{ fontSize: "19px" }} >Were there any other vehicles or property damaged in the loss?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurAccident}
                      onChange={event => {
                        setAccidentUser({
                          ...accidentUser,
                          anyOtherVehiclesInvolved: event.target.value
                        })
                      }}
                      value={accidentUser.anyOtherVehiclesInvolved}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                {
                  accidentUser.anyOtherVehiclesInvolved === 'Yes' && (
                    <>
                      {
                        accidentUser.vehicleInvolved.map((value, index) => {
                          return <div key={index}>
                            <Row>
                              <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                                <Divider />
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                                <Input
                                  type="tel" pattern="[0-9]*" inputmode="numeric"
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Year"
                                  maxLength="4"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'year', index)}
                                  value={value['year']}
                                  defaultValue={value['year']}
                                />
                              </Col>
                              <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Make"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'make', index)}
                                  value={value['make']}
                                  defaultValue={value['make']}
                                />
                              </Col>
                              <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Model"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'model', index)}
                                  value={value['model']}
                                  defaultValue={value['model']}
                                />
                              </Col>
                              {accidentUser.vehicleInvolved.length > 1 && (
                                <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                                  <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteVehicleInfoAccItem(index)}>
                                    Delete
                                  </Button>
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Other carrier name"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'otherCarrierName', index)}
                                  value={value['otherCarrierName']}
                                  defaultValue={value['otherCarrierName']}
                                />
                              </Col>
                              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Other carrier policy #"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'otherCarrierClaim', index)}
                                  value={value['otherCarrierClaim']}
                                  defaultValue={value['otherCarrierClaim']}
                                />
                              </Col>
                            </Row>
                            <br />
                            <Row>
                              <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                                <TextArea
                                  style={{ fontSize: "19px", border: "1px solid #376998" }}
                                  rows={4}
                                  placeholder="Describe the vehicle or property damage"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'describeProperty', index)}
                                  value={value['describeProperty']}
                                  defaultValue={value['describeProperty']}
                                />
                              </Col>
                            </Row>
                            <h5>Owner Name and Address</h5>
                            <Row>
                              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  placeholder="First Name*"
                                  onBlur={onBlurAccident}
                                  className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.vehicleInvolved[index]?.cureOwnerInfo?.hasOwnProperty('FirstName')
                                    ? !mandatoryAccidentalUser.vehicleInvolved[index].cureOwnerInfo.FirstName
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.FirstName', index)}
                                  value={value.cureOwnerInfo.FirstName}
                                  defaultValue={value.cureOwnerInfo.FirstName}

                                />
                              </Col>
                              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  placeholder="Last Name*"
                                  onBlur={onBlurAccident}
                                  className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.vehicleInvolved[index]?.cureOwnerInfo?.hasOwnProperty('LastName')
                                    ? !mandatoryAccidentalUser.vehicleInvolved[index].cureOwnerInfo.LastName
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.LastName', index)}
                                  value={value.cureOwnerInfo.LastName}
                                  defaultValue={value.cureOwnerInfo.LastName}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]}`}
                                  placeholder="Email Address"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.EmailAddress', index)}
                                  value={value.cureOwnerInfo.EmailAddress}
                                  defaultValue={value.cureOwnerInfo.EmailAddress}
                                />
                              </Col>
                              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <InputMask
                                  type="tel" pattern="[0-9]*" inputmode="numeric"
                                  className={`${FNOLStyle["input-text"]}`}
                                  mask="(999) 999-9999"
                                  placeholder="Phone Number"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.PhoneNumber', index)}
                                  value={value.cureOwnerInfo.PhoneNumber}
                                  defaultValue={value.cureOwnerInfo.PhoneNumber}
                                />
                              </Col>
                              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  onBlur={onBlurAccident}
                                  className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.vehicleInvolved[index]?.cureOwnerInfo?.hasOwnProperty('StreetAddress')
                                    ? !mandatoryAccidentalUser.vehicleInvolved[index].cureOwnerInfo.StreetAddress
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  placeholder="Street Address*"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.StreetAddress', index)}
                                  value={value.cureOwnerInfo.StreetAddress}
                                  defaultValue={value.cureOwnerInfo.StreetAddress}
                                />
                              </Col>
                              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  onBlur={onBlurAccident}
                                  className={`input-text`}
                                  placeholder="Apartment #"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.ApartmentNo', index)}
                                  value={value.cureOwnerInfo.ApartmentNo}
                                  defaultValue={value.cureOwnerInfo.ApartmentNo}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.vehicleInvolved[index]?.cureOwnerInfo?.hasOwnProperty('City')
                                    ? !mandatoryAccidentalUser.vehicleInvolved[index].cureOwnerInfo.City
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  placeholder="City*"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.City', index)}
                                  value={value.cureOwnerInfo.City}
                                  defaultValue={value.cureOwnerInfo.City}
                                />
                              </Col>
                              <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  autoComplete="off"
                                  className={`input-text`}
                                  placeholder="State*"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.State', index)}
                                  value={value.cureOwnerInfo.State}
                                  defaultValue={value.cureOwnerInfo.State}
                                />
                              </Col>
                              <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Input
                                  type="tel" pattern="[0-9]*" inputmode="numeric"
                                  autoComplete="off"
                                  onBlur={onBlurAccident}
                                  className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.vehicleInvolved[index]?.cureOwnerInfo?.hasOwnProperty('ZipCode')
                                    ? !mandatoryAccidentalUser.vehicleInvolved[index].cureOwnerInfo.ZipCode
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                    }`}
                                  placeholder="Zip Code*"
                                  maxLength="5"
                                  onChange={event => updateVehicleInvolvedAccVehicle(event.target.value, 'cureOwnerInfo.ZipCode', index)}
                                  value={value.cureOwnerInfo.ZipCode}
                                  defaultValue={value.cureOwnerInfo.ZipCode}
                                />
                              </Col>
                            </Row>
                            <Row>
                              {accidentUser.vehicleInvolved.length > 1 && (
                                <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                                  <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteVehicleInfoAccItem(index)}>
                                    Delete
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </div>
                        })
                      }
                      <Row>
                        <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                          <Button
                            type="primary"
                            style={{
                              marginBottom: 16,
                              background: '#294c7c',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                            onClick={() => handleAddingMultipleVehiclesInfoAcc()}
                          >
                            Add Another Vehicle or Property
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryAccidentalUser.hasOwnProperty('wereThereAnyPassengersInVehicle')
                      ? !mandatoryAccidentalUser.wereThereAnyPassengersInVehicle
                        ? 'error-text'
                        : ''
                      : ''}`}
                      style={{ fontSize: "19px" }}>Were there any passengers in your vehicle?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurAccident}
                      onChange={event => {
                        setAccidentUser({
                          ...accidentUser,
                          wereThereAnyPassengersInVehicle: event.target.value
                        })
                      }}
                      value={accidentUser.wereThereAnyPassengersInVehicle}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                {accidentUser.wereThereAnyPassengersInVehicle === 'Yes' && (
                  <>
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <h5>Passengers</h5>
                      </Col>
                    </Row>

                    {accidentUser.passengersInvehiclesLists.map((value, index) => (
                      <div key={index}>
                        <Row>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              onBlur={onBlurAccident}
                              className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.passengersInvehiclesLists.length > index ?
                                mandatoryAccidentalUser.passengersInvehiclesLists[index].hasOwnProperty('FirstName')
                                  ? !mandatoryAccidentalUser.passengersInvehiclesLists[index].FirstName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                : ''
                                }`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'FirstName', index)
                              }
                              placeholder="First Name*"
                              value={value['FirstName']}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              onBlur={onBlurAccident}
                              className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.passengersInvehiclesLists.length > index ?
                                mandatoryAccidentalUser.passengersInvehiclesLists[index].hasOwnProperty('LastName')
                                  ? !mandatoryAccidentalUser.passengersInvehiclesLists[index].LastName
                                    ? !alreadySubmitted ? '' : 'error-border'
                                    : ''
                                  : ''
                                : ''
                                }`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'LastName', index)
                              }
                              placeholder="Last Name*"
                              value={value['LastName']}
                            />
                          </Col>
                          {accidentUser.passengersInvehiclesLists.length > 1 && (
                            <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                              <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteAccidentalPassengerItem(index)}>
                                Delete
                              </Button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'EmailAddress', index)
                              }
                              placeholder="Email"
                              value={value['EmailAddress']}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <InputMask
                              type="tel" pattern="[0-9]*" inputmode="numeric"
                              className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                              mask="(999) 999-9999"
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'PhoneNumber', index)
                              }
                              placeholder="Phone Number"
                              value={value['PhoneNumber']}
                            />
                          </Col>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'StreetAddress', index)
                              }
                              placeholder="Street Address"
                              value={value['StreetAddress']}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'ApartmentNo', index)
                              }
                              placeholder="Apartment #"
                              value={value['ApartmentNo']}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'City', index)
                              }
                              placeholder="City"
                              value={value['City']}
                            />
                          </Col>
                          <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'State', index)
                              }
                              placeholder="State"
                              value={value['State']}
                            />
                          </Col>
                          <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              type="tel" pattern="[0-9]*" inputmode="numeric"
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              placeholder="Zip Code"
                              maxLength="5"
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'ZipCode', index)
                              }
                              value={value['ZipCode']}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Text style={{ fontSize: "19px" }}>Was this person injured? {`  `}</Text>
                            <Radio.Group
                              onChange={event =>
                                updateAccidentalPassengerInInVehicle(event.target.value, 'isPersonInjured', index)
                              }
                              value={value['isPersonInjured']}
                            >
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        {value['isPersonInjured'] === 'Yes' && (
                          <Row>
                            <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                              <TextArea
                                style={{ fontSize: "19px", border: "1px solid #376998" }}
                                rows={4}
                                onBlur={onBlurAccident}
                                className={`${mandatoryAccidentalUser.passengersInvehiclesLists.length > index ?
                                  mandatoryAccidentalUser.passengersInvehiclesLists[index].hasOwnProperty('description')
                                    ? !mandatoryAccidentalUser.passengersInvehiclesLists[index].description
                                      ? !alreadySubmitted ? '' : 'error-border'
                                      : ''
                                    : ''
                                  : ''
                                  }`}
                                placeholder="Description of injury*"
                                onChange={event =>
                                  updateAccidentalPassengerInInVehicle(event.target.value, 'description', index)
                                }
                                value={value['description']}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row>
                          {accidentUser.passengersInvehiclesLists.length > 1 && (
                            <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                              <Button type="danger" shape="round" onClick={() => deleteAccidentalPassengerItem(index)}>
                                Delete
                              </Button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                            <Divider />
                          </Col>
                        </Row>
                      </div>
                    ))}
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <Button
                          type="primary"
                          style={{
                            marginBottom: 16,
                            background: '#294c7c',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                          onClick={handleAddingPassengersInAccidentInjuries}
                        >
                          Add Another Passenger
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text className={`${mandatoryAccidentalUser.hasOwnProperty('wereThereAnyInjuriesInLoss')
                      ? !mandatoryAccidentalUser.wereThereAnyInjuriesInLoss
                        ? 'error-text'
                        : ''
                      : ''}`}
                      style={{ fontSize: "19px" }}>Was anyone else injured in this loss?* {`  `}</Text>
                    <Radio.Group
                      onMouseLeave={onBlurAccident}
                      onChange={event => {
                        setAccidentUser({
                          ...accidentUser,
                          wereThereAnyInjuriesInLoss: event.target.value
                        })
                      }}
                      value={accidentUser.wereThereAnyInjuriesInLoss}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                {accidentUser.wereThereAnyInjuriesInLoss === 'Yes' && (
                  <>
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <h5>Injured Person</h5>
                      </Col>
                    </Row>

                    {accidentUser.injuriesInLossLists.map((value_, index) => (
                      <div key={index}>
                        <Row>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              onBlur={onBlurAccident}
                              className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.injuriesInLossLists[index].hasOwnProperty('FirstName')
                                ? !mandatoryAccidentalUser.injuriesInLossLists[index].FirstName
                                  ? !alreadySubmitted ? '' : 'error-border'
                                  : ''
                                : ''
                                }`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'FirstName', index)}
                              placeholder="First Name*"
                              value={value_.FirstName}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              onBlur={onBlurAccident}
                              className={`${FNOLStyle["input-text"]} ${mandatoryAccidentalUser.injuriesInLossLists[index].hasOwnProperty('LastName')
                                ? !mandatoryAccidentalUser.injuriesInLossLists[index].LastName
                                  ? !alreadySubmitted ? '' : 'error-border'
                                  : ''
                                : ''
                                }`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'LastName', index)}
                              placeholder="Last Name*"
                              value={value_.LastName}
                            />
                          </Col>
                          {accidentUser.injuriesInLossLists.length > 1 && (
                            <Col xl={{ span: 4, offset: 1 }} xs={{ span: 0 }}>
                              <Button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} type="danger" shape="round" onClick={() => deleteAccidentalItem(index)}>
                                Delete
                              </Button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'EmailAddress', index)}
                              placeholder="Email"
                              value={value_.EmailAddress}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <InputMask
                              type="tel" pattern="[0-9]*" inputmode="numeric"
                              className={`${FNOLStyle["input-text"]} ${FNOLStyle["phone-number"]}`}
                              mask="(999) 999-9999"
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'PhoneNumber', index)}
                              placeholder="Phone Number"
                              value={value_.PhoneNumber}
                            />
                          </Col>
                          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'StreetAddress', index)}
                              placeholder="Street Address"
                              value={value_.StreetAddress}
                            />
                          </Col>
                          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'ApartmentNo', index)}
                              placeholder="Apartment #"
                              value={value_.ApartmentNo}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'City', index)}
                              placeholder="City"
                              value={value_.City}
                            />
                          </Col>
                          <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'State', index)}
                              placeholder="State"
                              value={value_.State}
                            />
                          </Col>
                          <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                            <Input
                              type="tel" pattern="[0-9]*" inputmode="numeric"
                              autoComplete="off"
                              className={`${FNOLStyle["input-text"]}`}
                              placeholder="Zip Code"
                              maxLength="5"
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'ZipCode', index)}
                              value={value_.ZipCode}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                            <TextArea
                              style={{ fontSize: "19px", border: "1px solid #376998" }}
                              rows={4}
                              onBlur={onBlurAccident}
                              className={`${mandatoryAccidentalUser.injuriesInLossLists[index].hasOwnProperty('description')
                                ? !mandatoryAccidentalUser.injuriesInLossLists[index].description
                                  ? !alreadySubmitted ? '' : 'error-border'
                                  : ''
                                : ''
                                }`}
                              placeholder="Description of injury*"
                              onChange={event => updateAcciedentalInVehicle(event.target.value, 'description', index)}
                              value={value_.description}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {accidentUser.injuriesInLossLists.length > 1 && (
                            <Col xl={{ span: 0 }} xs={{ span: 4, offset: 0 }}>
                              <Button type="danger" shape="round" onClick={() => deleteAccidentalItem(index)}>
                                Delete
                              </Button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                            <Divider />
                          </Col>
                        </Row>
                      </div>
                    ))}
                    <Row>
                      <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                        <Button
                          type="primary"
                          style={{
                            marginBottom: 16,
                            background: '#294c7c',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                          onClick={handleAddingAccidentInjuries}
                        >
                          Add Injury
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
                { <Row>
                  <Col xl={{ span: 17 }} xs={{ span: 24 }}>
                    <Text style={{ fontSize: "19px" }}>Please select your preferred delivery method. &nbsp;</Text>
                    <Radio.Group
                      onMouseLeave={onBlurAccident}
                      onChange={event => {
                        setAccidentUser({
                          ...accidentUser,
                          preferredDeliveryMethod: event.target.value
                        })
                      }}
                      value={accidentUser.preferredDeliveryMethod}
                    >
                      <Radio value="Email">Email</Radio>
                      <Radio value="Mail">Mail</Radio>
                    </Radio.Group>
                  </Col>
                </Row>}
                <Row style={{ marginBottom: "30px", marginTop: "30px" }}>
                  <Checkbox onMouseLeave={onBlurAccident} onChange={e => { console.log(e); setAccidentAttested(e.target.checked) }} style={{ color: !accidentAttested && alreadySubmitted ? "red" : "unset", fontSize: "19px" }}>I hereby certify that, to the best of my knowledge, the provided information is true and accurate.†</Checkbox>
                </Row>
                {displayAccidentMissingFieldMessage && <Row>
                  <Space>
                    <Text style={{ color: "red", fontSize: "19px" }}>Please complete all required fields.</Text>
                  </Space>
                </Row>}
                {displayBlockedMessage && <Row>
                  <Space>
                    <Text style={{ color: "red", fontSize: "19px" }}>Something went wrong, please call 1-800-535-2873 to start your quote.</Text>
                  </Space>
                </Row>}
                <Row className={`${FNOLStyle["submit-container"]}`}>
                  <Space>
                    <Button className={`${FNOLStyle["register"]} ${FNOLStyle["register-form-button"]}`} onClick={() => handleAccidentSubmit()} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      Submit
                    </Button>
                    {showAccidentSpinner && <Col style={{ paddingBottom: 0 }}><Spin indicator={antIcon} /></Col>}
                  </Space>
                </Row>
                <Row style={{ marginTop: "20px" }}><Paragraph>†The Michigan Department of Insurance and Financial Services defines insurance fraud as providing “false information to an insurance company in order to gain something of value that he or she would not have received if the truth had been told[.]” Under Michigan law, it is unlawful to present to any insurer or agent thereof any oral or written statement knowing that the statement contains any false information concerning any fact material to an application for the issuance of an insurance policy or a claim.{"\n"}</Paragraph></Row>
                <Row><Paragraph>†Pursuant to New Jersey regulations, “Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.”{"\n"}</Paragraph></Row>
                <Row><Paragraph>†Pursuant to Pennsylvania regulations, “Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.”{"\n"}</Paragraph></Row>
              </Card>
            </Form>
          )}
        </div>
      </Row>
    </>
  )
}

FNOL.propTypes = {}

export default FNOL
